/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import classes from "./order.module.css";
import CartBlock from "../checkout/review/cartBlock";
import Loader from "../../../component/loader";
import CustomerDetailBlock from "../checkout/review/customerDetailsBlock";
import { Routes as RouterSwitch, Route, Navigate } from "react-router-dom";
import Catalog from "../catalog/catalog";
import Product from "../product/product";
import Button from "../../../component/button";
import Action from "./action";
import ResendDialog from "./resendDialog";
import CancelOrderDialog from "./cancelOrderDialog";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import OrderHistory from "../orderHistory/orderHistory";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import UpdateOrderContact from "../updateOrderContact/updateOrderContact";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import { InfoIcon } from "../../../component/icons/icons";
import Grid from "@mui/material/Grid";
import statusClasses from "../orderHistory/orderHistory.module.css";
import { Tooltip } from "@mui/material";
import { IconButton, Box } from "@mui/material";
import { ReturnIcon, ProcessOrderIcon } from "../../../component/icons/icons";
// import the constant routes
import Routes from "../../../helper/routeConstants";
import GenericBPMNForm from "../../../component/genericBPMNForm/genericBPMNForm";
import OrderActionDialog from "./orderActionDialog";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Draggable from "react-draggable";
import { Paper, Icon } from "@mui/material";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import Input from "../../../component/inputpm/index.js";
import PartialOrderProcessDialog from "./partialOrderProcessDialog.js";
import EditPartialOrderProcessDialog from "./editPartialOrderProcessDialog.js";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Card,
} from "@mui/material";
import pdfIcon from "../../../asset/images/pdf.png";
import jpgIcon from "../../../asset/images/jpg.png";
import pngIcon from "../../../asset/images/png.png";
import placeholderImage from "../../../asset/images/image_placeholder.png";
// import { withStyles } from '@mui/styles';
import { DeleteIconNew } from "../../../component/icons/icons.js";
import UriEncode from "../../../component/uriEncode/uriEncode.js";
import { withNavigation } from "../../../helper/withNavigation.js";
import OfferingProductSpecCharacteristicsExistingDialog from "../../pm/component/specification/offeringProductSpecCharacteristicsExistingDialog.js";
import OfferingProductSpecCharacteristicsDialog from "../../pm/component/specification/offeringProductSpecCharacteristicsDialog.js";
import { formatDate } from "../../../helper/dateFormatter";
var _html = require("../orderDiagram/diagram.html.js");
var diagramTemplate = { __html: _html };

// Order view page parent class
class Order extends Component {
  // Declare property values that belongs to the component
  state = {
    edit: {},
    solutions: [],
    accessories: [],
    cart: [],
    originalOrder: null,
    loading: true,
    customerDetails: null,
    orderId: "",
    customerPartyId: "",
    show: false,
    modify: false,
    status: "",
    msg: "",
    isMailDialog: false,
    isCancelDialog: false,
    statusHistory: [],
    subscriptionChangeHistory: [],
    tcInformation: {},
    tcLinks: [],
    autoActivatable: false,
    orderActivationStatus: null,
    oldBan: null,
    bread: [],
    orderUpdateDate: null,
    today: null,
    updateOrderLabel:
      this.props.providerType === "SALES_CHNL_PROVIDER"
        ? this.props.t("UPDATE_ORDER")
        : this.props.t("UPDATE_FULFILMENT_REQUEST"),
    cancelOrderLabel:
      this.props.providerType === "SALES_CHNL_PROVIDER"
        ? this.props.t("REJECT_ORDER")
        : this.props.t("REJECT_FULFILMENT_REQUEST"),
    isApprovedChecked: false,
    tenantId: null,
    showActions: true,
    orderBillToCustomerId: null,
    downloadInvoice: false,
    viewInvoice: false,
    invoiceId: null,
    showOrderInvoice: false,
    disableInvoiceBtn: true,
    renderActions: false,
    userPerms: this.props.userPermsm,
    vRoute: [],
    actionDialog: false,
    formFields: {},
    processInstanceDiagram: "",
    bpmnProcessInstanceId: "",
    workFlowEnabled: false,
    is_order_status: false,
    order_status_details: {},
    showActionsPanel: false,
    returnOrders: [],
    totalRCDiscount: 0,
    totalNRDiscount: 0,
    orderCustomer: "",
    orderItemLocations: [],
    renderCartBlock: false,
    associatedOrder: [],
    note: [],
    externalId: "",
    tempExternalId: "",
    showCustomerOrderNumberDialog: false,
    attachments: [],
    showPartialProcessDialog: false,
    processingItemData: [],
    orderType: "",
    returnableItemList: [],
    selectedChildProcessData: {},
    showChildActionDailog: false,
    orderDate: "",
    actionStatus: "",
    isEligibleUser: "",
    orderDiscount: 0,

    editProcessingItemData: [],
    editPartialProcessDialog: false,
    orderTypeDescription: "",
    orderTotalDiscount: {},
    notes: "",
    showUploadDailog: false,
    assessmentData: {
      name: "",
      data: "",
      format: "",
      fileName: "",
      isPublic: "N",
    },
    uploadAssesmentError: {
      show: false,
      msg: "",
    },
    subsHistoryPage: 1,
    subsHistoryPerPage: 10,
    subsHistoryStartRecord: 1,
    subsHistoryTotalRecords: 0,
    sortOrderSubs: "DESC",
    sortBySubs: "subscriptionId",
    subscriptionData: [],

    selectedProductSpecificationOffering: {},
    selectedProductSpecification: {},
    showProductSpecification: false,
    selectedCharacteristics: [],
    packageInstanceBilled: false
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    let vRoute = [];
    for (let [route, component, name] of Routes.orderRoutes.entries()) {
      if (this.props.menuPaths.includes(route)) {
        vRoute.push({
          path: route,
          comp: component,
          exact: true,
          name: component.WrappedComponent.name,
        });
      }
    }
    this.setState({
      vRoute: vRoute,
    });
    // Remove error message on component load
    this.props.setCompDidMount();
    let date = new Date();
    let today = `${date.getFullYear()}-${date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate()}`;
    // Get order details

    this.checkOrderForInvoice();

    this.getFullOrderDetails();

    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    if (tenantId) {
      this.setState({
        tenantId,
      });
    }
    let bread = [
      {
        title:
          this.props.providerType === "SALES_CHNL_PROVIDER"
            ? this.props.t("ORDERS")
            : this.props.t("FULFILMENT_REQUEST"),
        url: "/orders",
      },
      {
        title: this.props.router.params.orderId,
        url: tenantId
          ? `/order/${this.props.router.params.orderId}?tenantId=${tenantId}`
          : `/order/${this.props.router.params.orderId}`,
      },
    ];
    this.setState({
      bread,
      today,
      orderId: this.props.router.params.orderId,
    });
    this.handleCheck = this.handleCheck.bind(this);
  }

  handleCheck(event) {
    var isApprovedChecked = event.target.checked;
    this.setState({ isApprovedChecked: isApprovedChecked });
  }

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  // This function will check if order has any item available for invoice.
  checkOrderForInvoice = () => {
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let payload = {
      tenantId: tenantId,
    };
    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders/${this.props.router.params.orderId}/itemsAvailableForInvoice`,
      payload,
    )
      .then((res) => {
        let data = res.data;
        this.setState({
          orderBillToCustomerId: data.ban,
          showOrderInvoice: data.itemsAvailableForInvoice,
          viewInvoice: data.viewInvoice,
          downloadInvoice: data.downloadInvoice,
          invoiceId: data.invoiceId,
          disableInvoiceBtn: !data.itemsAvailableForInvoice,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        // this.setState({ loading: false })
      });
  };

  // This function is used to get Order details
  getFullOrderDetails = () => {
    this.setState({ loading: true });

    // Get order id from URL params
    let orderIdUrlParam = this.props.router.params.orderId;
    // this.getOrderAttachments(orderIdUrlParam);
    // Get order summary
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let data = {};
    if (tenantId) {
      data = {
        tenantId: tenantId,
      };
    }
    let payLoad = {
      orderId: orderIdUrlParam,
    };
    var urls = [
      BusApiCall(
        "GET",
        `${constants.busV4Url}/orders/${orderIdUrlParam}`,
        data,
      ),
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/orders/${orderIdUrlParam}/history`,
        data,
      ),
      BusApiCall(
        "GET",
        `${constants.busV4Url}/orders/${this.props.router.params.orderId}/itemsAvailableForInvoice`,
        data,
      ),
      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/orders/${orderIdUrlParam}/packageOrderItems`,
        data,
      ),
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/GET_ORDER_RETURNABLE_ITEMS/endpoint`,
        payLoad,
      ),
      this.getOrderAttachments(orderIdUrlParam),
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/orders/${orderIdUrlParam}/contacts`,
        data,
      ),
    ];
    if (
      !this.state.tenantId &&
      this.props.providerType === "SALES_CHNL_PROVIDER"
    ) {
      // urls.push(BusApiCall('GET', `${constants.busInternalUrl}/orders/${orderIdUrlParam}/contacts`));
      urls.push(
        BusApiCall(
          "GET",
          `${constants.busInternalUrl}/orders/${orderIdUrlParam}/terms/content`,
        ),
      );
      urls.push(
        BusApiCall(
          "GET",
          `${constants.busInternalUrl}/orders/${orderIdUrlParam}/promos`,
        ),
      );
    }
    Promise.all(urls)
      .then((allRes) => {
        // console.log('allres======', allRes);
        var orderData = allRes[0].data;
        var historyRes = allRes[1].data.orderHistory;
        var invoiceData = allRes[2].data;
        var processingItemData = allRes[3].data;
        var returnableItemList = allRes[4].data.returnableItemList;
        var attachmentData = allRes[5]?.data?.attachments || [];
        this.setState({ returnableItemList });
        // var custRes = {};
        var custRes = allRes[6].data;
        var tcLinks = [];
        var oldBan = "";
        if (urls.length > 7) {
          // custRes = allRes[6].data;
          tcLinks = allRes[7].data.orderTermContentList;
          oldBan = allRes[8].data.banList[0];
        }
        if (attachmentData) {
          this.setState({
            attachments: attachmentData,
          });
        }
        if (orderData.orderItems) {
          this.setState(
            {
              orderCustomer: orderData.customer,
            },
            () => {
              this.getOrderSubscriptions();
            },
          );
          // Order data starts here
          // Start: Get Order items details
          var originalOrder = {};
          let newSolutions = [];
          let newAccessories = [];
          let autoActivatable = false;
          if (true) {
            let solIndex = 0;
            var totalNRDiscount = 0;
            var totalRCDiscount = 0;
            // Check each iitem in order

            for (let item of orderData.orderItems) {
              if (item.associatedProducts) {
                let data = {};
                // Start: Get packaged solution details
                data.name = item.productName;
                data.id = item.productId;
                data.packageId = item.packageId;
                data.quantity = JSON.parse(item.quantity);
                data.index = solIndex;
                data.type = "SOL";
                data.discount = item.discount;
                data.sellable = item.sellable ? item.sellable : false;
                data.locationDetail = item.locationDetail
                  ? item.locationDetail
                  : {};
                data.parentSubscriptionId = item.parentSubscriptionId;
                data.parentSubscriptionName = item.parentSubscriptionName;
                // Start: Get packaged solution details
                solIndex++;

                // Check that addons and setup quantity in modifiable
                // Since in some products user can set their individual quantity
                // if (item.associatedProducts.some(obj => obj.associationType === 'SOLUTION_PLAN')) {
                // } else {
                //     data.addOnQuantMod = true;
                //     data.setupQuantMod = true;
                // }

                data.associatedItems = [];
                if (item.associatedProducts.length > 0) {
                  for (var k = 0; k < item.associatedProducts.length; k++) {
                    for (
                      var l = 0;
                      l < item.associatedProducts[k].products.length;
                      l++
                    ) {
                      const originalPrice = item.associatedProducts[k].products[l].amount;
                      item.associatedProducts[k].products[l].originalPrice = originalPrice;
                      if (this.props.providerType === "SALES_CHNL_PROVIDER") {
                        if (
                          !item.associatedProducts[k].products[l]
                            .customerViewable
                        ) {
                          var viewableIndex = item.associatedProducts[
                            k
                          ].products.findIndex((x) => x.customerViewable);
                          if (viewableIndex > -1) {
                            if (
                              item.associatedProducts[k].products[viewableIndex]
                                .alreadyAdded
                            ) {
                            } else {
                              if (
                                item.associatedProducts[k].products[
                                  viewableIndex
                                ].chargeType === "RC"
                              ) {
                                var viewableItem =
                                  item.associatedProducts[k].products[
                                  viewableIndex
                                  ];
                                if (viewableItem.chargeTerm) {
                                  var key = `${viewableItem.chargeTerm.termPeriod}_${viewableItem.chargeTerm.termUomId}`;
                                  var found = false;
                                  var updatedList = viewableItem.recurringCost
                                    ? [...viewableItem.recurringCost]
                                    : [];
                                  for (var m = 0; m < updatedList.length; m++) {
                                    if (updatedList[m].key === key) {
                                      updatedList[m].amount +=
                                        viewableItem.amount;
                                      found = true;
                                      break;
                                    }
                                  }

                                  if (!found) {
                                    var newObj = {
                                      key: key,
                                      termPeriod:
                                        viewableItem.chargeTerm.termPeriod,
                                      tenureUom:
                                        viewableItem.chargeTerm.termUomId,
                                      amount: viewableItem.amount,
                                    };
                                    updatedList.push(newObj);
                                  }
                                  viewableItem.recurringCost = updatedList;
                                }
                                // if (item.associatedProducts[k].products[viewableIndex].recurringCost) {
                                //     item.associatedProducts[k].products[viewableIndex].recurringCost = item.associatedProducts[k].products[viewableIndex].recurringCost + item.associatedProducts[k].products[viewableIndex].amount;
                                // } else {
                                //     item.associatedProducts[k].products[viewableIndex].recurringCost = item.associatedProducts[k].products[viewableIndex].amount;
                                // }
                              } else {
                                if (
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].nonRecurringCost
                                ) {
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].nonRecurringCost =
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].nonRecurringCost +
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].amount;
                                } else {
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].nonRecurringCost =
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].amount;
                                }
                              }
                              if (
                                item.associatedProducts[k].products[
                                  viewableIndex
                                ].otherPrices &&
                                item.associatedProducts[k].products[
                                  viewableIndex
                                ].otherPrices.length > 0
                              ) {
                                for (
                                  var m = 0;
                                  m <
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].otherPrices.length;
                                  m++
                                ) {
                                  if (
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].otherPrices[m].priceType === "DEPOSIT"
                                  ) {
                                    if (
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].depositPrice
                                    ) {
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].depositPrice =
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].depositPrice +
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].otherPrices[m].price;
                                    } else {
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].depositPrice =
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].otherPrices[m].price;
                                    }
                                  }
                                  if (
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].otherPrices[m].priceType ===
                                    "USAGE_CHARGE"
                                  ) {
                                    if (
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].usageCharge
                                    ) {
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].usageCharge =
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].usageCharge +
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].otherPrices[m].price;
                                    } else {
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].usageCharge =
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].otherPrices[m].price;
                                    }
                                  }
                                  if (
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].otherPrices[m].priceType === "SETUP_FEE"
                                  ) {
                                    if (
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].setupFee
                                    ) {
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].setupFee =
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].setupFee +
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].otherPrices[m].price;
                                    } else {
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].setupFee =
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].otherPrices[m].price;
                                    }
                                  }
                                  if (
                                    orderData.type === "CancelSubscription" ||
                                    orderData.type === "TerminateSubscription"
                                  ) {
                                    if (
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].otherPrices[m].priceType ===
                                      "CANCELLATION_PRICE"
                                    ) {
                                      if (
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].cancellationPrice
                                      ) {
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].cancellationPrice =
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].cancellationPrice +
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].otherPrices[m].price;
                                      } else {
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].cancellationPrice =
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].otherPrices[m].price;
                                      }
                                    }
                                  }
                                  if (orderData.type === "ShiftSubscription") {
                                    if (
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].otherPrices[m].priceType ===
                                      "SHIFT_PRICE"
                                    ) {
                                      if (
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].shiftPrice
                                      ) {
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].shiftPrice =
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].shiftPrice +
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].otherPrices[m].price;
                                      } else {
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].shiftPrice =
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].otherPrices[m].price;
                                      }
                                    }
                                  }
                                  if (
                                    orderData.type === "SuspendSubscription"
                                  ) {
                                    if (
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].otherPrices[m].priceType ===
                                      "SUSPENSION_PRICE"
                                    ) {
                                      if (
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].suspendPrice
                                      ) {
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].suspendPrice =
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].suspendPrice +
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].otherPrices[m].price;
                                      } else {
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].suspendPrice =
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].otherPrices[m].price;
                                      }
                                    }
                                  }
                                  if (orderData.type === "ResumeSubscription") {
                                    if (
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].otherPrices[m].priceType ===
                                      "REACTIVATION_PRICE"
                                    ) {
                                      if (
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].resumePrice
                                      ) {
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].resumePrice =
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].resumePrice +
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].otherPrices[m].price;
                                      } else {
                                        item.associatedProducts[k].products[
                                          viewableIndex
                                        ].resumePrice =
                                          item.associatedProducts[k].products[
                                            viewableIndex
                                          ].otherPrices[m].price;
                                      }
                                    }
                                  }
                                }
                              }
                              item.associatedProducts[k].products[
                                viewableIndex
                              ].alreadyAdded = true;
                            }
                          }
                          if (
                            item.associatedProducts[k].products[l]
                              .chargeType === "RC"
                          ) {
                            var viewableItem =
                              item.associatedProducts[k].products[l];
                            if (viewableItem.chargeTerm) {
                              var key = `${viewableItem.chargeTerm.termPeriod}_${viewableItem.chargeTerm.termUomId}`;
                              var found = false;
                              var updatedList = item.associatedProducts[k]
                                .products[viewableIndex].recurringCost
                                ? [
                                  ...item.associatedProducts[k].products[
                                    viewableIndex
                                  ].recurringCost,
                                ]
                                : [];
                              for (var m = 0; m < updatedList.length; m++) {
                                if (updatedList[m].key === key) {
                                  updatedList[m].amount += viewableItem.amount;
                                  found = true;
                                  break;
                                }
                              }

                              if (!found) {
                                var newObj = {
                                  key: key,
                                  termPeriod:
                                    viewableItem.chargeTerm.termPeriod,
                                  tenureUom: viewableItem.chargeTerm.termUomId,
                                  amount: viewableItem.amount,
                                };
                                updatedList.push(newObj);
                              }
                              item.associatedProducts[k].products[
                                viewableIndex
                              ].recurringCost = updatedList;
                            }
                            // if (item.associatedProducts[k].products[viewableIndex].recurringCost) {
                            //     item.associatedProducts[k].products[viewableIndex].recurringCost = item.associatedProducts[k].products[viewableIndex].recurringCost + item.associatedProducts[k].products[l].amount;
                            // } else {
                            //     item.associatedProducts[k].products[viewableIndex].recurringCost = item.associatedProducts[k].products[l].amount;
                            // }
                          } else {
                            if (
                              item.associatedProducts[k].products[viewableIndex]
                                .nonRecurringCost
                            ) {
                              item.associatedProducts[k].products[
                                viewableIndex
                              ].nonRecurringCost =
                                item.associatedProducts[k].products[
                                  viewableIndex
                                ].nonRecurringCost +
                                item.associatedProducts[k].products[l].amount;
                            } else {
                              item.associatedProducts[k].products[
                                viewableIndex
                              ].nonRecurringCost =
                                item.associatedProducts[k].products[l].amount;
                            }
                          }
                          if (
                            item.associatedProducts[k].products[l]
                              .otherPrices &&
                            item.associatedProducts[k].products[l].otherPrices
                              .length > 0
                          ) {
                            for (
                              var n = 0;
                              n <
                              item.associatedProducts[k].products[l].otherPrices
                                .length;
                              n++
                            ) {
                              if (
                                item.associatedProducts[k].products[l]
                                  .otherPrices[n].priceType === "DEPOSIT"
                              ) {
                                if (
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].depositPrice
                                ) {
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].depositPrice =
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].depositPrice +
                                    item.associatedProducts[k].products[l]
                                      .otherPrices[n].price;
                                } else {
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].depositPrice =
                                    item.associatedProducts[k].products[
                                      l
                                    ].otherPrices[n].price;
                                }
                              }
                              if (
                                item.associatedProducts[k].products[l]
                                  .otherPrices[n].priceType === "USAGE_CHARGE"
                              ) {
                                if (
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].usageCharge
                                ) {
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].usageCharge =
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].usageCharge +
                                    item.associatedProducts[k].products[l]
                                      .otherPrices[n].price;
                                } else {
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].usageCharge =
                                    item.associatedProducts[k].products[
                                      l
                                    ].otherPrices[n].price;
                                }
                              }
                              if (
                                item.associatedProducts[k].products[l]
                                  .otherPrices[n].priceType === "SETUP_FEE"
                              ) {
                                if (
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].setupFee
                                ) {
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].setupFee =
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].setupFee +
                                    item.associatedProducts[k].products[l]
                                      .otherPrices[n].price;
                                } else {
                                  item.associatedProducts[k].products[
                                    viewableIndex
                                  ].setupFee =
                                    item.associatedProducts[k].products[
                                      l
                                    ].otherPrices[n].price;
                                }
                              }
                              if (
                                orderData.type === "CancelSubscription" ||
                                orderData.type === "TerminateSubscription"
                              ) {
                                if (
                                  item.associatedProducts[k].products[l]
                                    .otherPrices[n].priceType ===
                                  "CANCELLATION_PRICE"
                                ) {
                                  if (
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].cancellationPrice
                                  ) {
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].cancellationPrice =
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].cancellationPrice +
                                      item.associatedProducts[k].products[l]
                                        .otherPrices[n].price;
                                  } else {
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].cancellationPrice =
                                      item.associatedProducts[k].products[
                                        l
                                      ].otherPrices[n].price;
                                  }
                                }
                              }
                              if (orderData.type === "ShiftSubscription") {
                                if (
                                  item.associatedProducts[k].products[l]
                                    .otherPrices[n].priceType === "SHIFT_PRICE"
                                ) {
                                  if (
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].shiftPrice
                                  ) {
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].shiftPrice =
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].shiftPrice +
                                      item.associatedProducts[k].products[l]
                                        .otherPrices[n].price;
                                  } else {
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].shiftPrice =
                                      item.associatedProducts[k].products[
                                        l
                                      ].otherPrices[n].price;
                                  }
                                }
                              }
                              if (orderData.type === "SuspendSubscription") {
                                if (
                                  item.associatedProducts[k].products[l]
                                    .otherPrices[n].priceType ===
                                  "SUSPENSION_PRICE"
                                ) {
                                  if (
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].suspendPrice
                                  ) {
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].suspendPrice =
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].suspendPrice +
                                      item.associatedProducts[k].products[l]
                                        .otherPrices[n].price;
                                  } else {
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].suspendPrice =
                                      item.associatedProducts[k].products[
                                        l
                                      ].otherPrices[n].price;
                                  }
                                }
                              }
                              if (orderData.type === "ResumeSubscription") {
                                if (
                                  item.associatedProducts[k].products[l]
                                    .otherPrices[n].priceType ===
                                  "REACTIVATION_PRICE"
                                ) {
                                  if (
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].resumePrice
                                  ) {
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].resumePrice =
                                      item.associatedProducts[k].products[
                                        viewableIndex
                                      ].resumePrice +
                                      item.associatedProducts[k].products[l]
                                        .otherPrices[n].price;
                                  } else {
                                    item.associatedProducts[k].products[
                                      viewableIndex
                                    ].resumePrice =
                                      item.associatedProducts[k].products[
                                        l
                                      ].otherPrices[n].price;
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        item.associatedProducts[k].products[
                          l
                        ].customerViewable = true;
                      }
                    }
                  }
                  if (item.specialPricing && item.specialPricing.promoId) {
                    var offeringQty = JSON.parse(item.quantity);
                    var rulesList = item.specialPricing.promoRuleList;
                    for (var j = 0; j < rulesList.length; j++) {
                      var conditionsList = rulesList[j].promoConditionList
                        ? rulesList[j].promoConditionList
                        : [];
                      var amount = 0;
                      if (
                        rulesList[j].promoActionList &&
                        rulesList[j].promoActionList.length > 0
                      ) {
                        amount = rulesList[j].promoActionList[0].amount;
                        var minimumQty = 0;
                        var maximumQty = 0;
                        if (conditionsList.length > 0) {
                          for (var k = 0; k < conditionsList.length; k++) {
                            if (
                              conditionsList[k].customMethodId ===
                              "PPC_PRODUCT_QUANT"
                            ) {
                              if (
                                conditionsList[k].operatorEnumId === "PPC_GTE"
                              ) {
                                minimumQty = Number(
                                  conditionsList[k].condValue,
                                );
                              }
                              if (
                                conditionsList[k].operatorEnumId === "PPC_LTE"
                              ) {
                                maximumQty = Number(
                                  conditionsList[k].condValue,
                                );
                              }
                            }
                            if (conditionsList.length === k + 1) {
                              if (
                                offeringQty >= minimumQty &&
                                offeringQty <= maximumQty
                              ) {
                                data.discountDetails = {
                                  value: amount,
                                  rcDiscount: 0,
                                  nrDiscount: 0,
                                };
                                for (
                                  var i = 0;
                                  i <
                                  item.associatedProducts[0].products.length;
                                  i++
                                ) {
                                  var discount =
                                    (item.associatedProducts[0].products[i]
                                      .amount *
                                      amount) /
                                    100;
                                  if (
                                    item.associatedProducts[0].products[i]
                                      .chargeType === "RC"
                                  ) {
                                    data.discountDetails.rcDiscount =
                                      data.discountDetails.rcDiscount +
                                      discount *
                                      (offeringQty *
                                        Number(
                                          item.associatedProducts[0].products[
                                            i
                                          ].quantity,
                                        ));
                                    totalRCDiscount =
                                      totalRCDiscount +
                                      discount *
                                      (offeringQty *
                                        Number(
                                          item.associatedProducts[0].products[
                                            i
                                          ].quantity,
                                        ));
                                  }
                                  if (
                                    item.associatedProducts[0].products[i]
                                      .chargeType === "NC"
                                  ) {
                                    data.discountDetails.nrDiscount =
                                      data.discountDetails.nrDiscount +
                                      discount *
                                      (offeringQty *
                                        Number(
                                          item.associatedProducts[0].products[
                                            i
                                          ].quantity,
                                        ));
                                    totalNRDiscount =
                                      totalNRDiscount +
                                      discount *
                                      (offeringQty *
                                        Number(
                                          item.associatedProducts[0].products[
                                            i
                                          ].quantity,
                                        ));
                                  }
                                  item.associatedProducts[0].products[i].price =
                                    this.setTempPrice(
                                      item.associatedProducts[0].products[i]
                                        .amount,
                                      item.associatedProducts[0].products[i]
                                        .chargeType,
                                    );
                                  if (
                                    i ===
                                    item.associatedProducts[0].products.length -
                                    1
                                  ) {
                                    data.associatedItems =
                                      item.associatedProducts[0].products;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    for (
                      var i = 0;
                      i < item.associatedProducts[0].products.length;
                      i++
                    ) {
                      item.associatedProducts[0].products[i].price =
                        this.setTempPrice(
                          item.associatedProducts[0].products[i].amount,
                          item.associatedProducts[0].products[i].chargeType,
                        );
                      if (
                        i ===
                        item.associatedProducts[0].products.length - 1
                      ) {
                        data.associatedItems =
                          item.associatedProducts[0].products;
                      }
                    }
                  }
                }
                if (data.associatedItems && data.associatedItems.length > 0) {
                  for (var s = 0; s < data.associatedItems.length; s++) {
                    data.associatedItems[s].productSpec = this.updateCategory(
                      data.associatedItems[s].productSpec,
                    );
                    // if (data.associatedItems[s].productSpec && data.associatedItems[s].productSpec.category && data.associatedItems[s].productSpec.category.id === 'PSC_CUST_FACING') {
                    //     const filteredJson = this.filterChildSpecs(data.associatedItems[s].productSpec);
                    //     data.associatedItems[s].productSpec = filteredJson;
                    // } else {
                    //     data.associatedItems[s].productSpec = {};
                    // }
                    const cleanedData = this.filterChildSpecs(
                      data.associatedItems[s].productSpec,
                    );
                    data.associatedItems[s].productSpec = cleanedData;
                  }
                }
                newSolutions.push(data);
              } else {
                // Get accessories
                let obj = {
                  id: item.productId,
                  name: item.productName,
                  quantity: +item.quantity,
                  price: +item.amount,
                };
                newAccessories.push(obj);
              }
            }
            if (newAccessories) {
              for (let i = 0; i < newAccessories.length; i++) {
                newAccessories[i].type = "ACC";
              }
            }
            // End: Get Order items details

            // Store original order data
            originalOrder = JSON.stringify({
              solutions: newSolutions,
              accessories: newAccessories,
            });

            // Check whether this order is auto-activated or not
            // Since our some devices are auto-activatable
            // And for some, users have to activate them manually
            for (let item of orderData.userData) {
              if (item.name === "autoActivatable") {
                autoActivatable = item.value;
              }
            }
          }
          // Order data ends here

          // Order status history items start
          if (historyRes) {
            if (historyRes.tcInformation) {
              if (
                historyRes.tcInformation.actionDate &&
                historyRes.tcInformation.actionDate !== "null"
              ) {
                historyRes.tcInformation.humanDate = formatDate(
                  historyRes.tcInformation.actionDate,
                  true,
                );
              } else {
                historyRes.tcInformation.humanDate = null;
              }
            } else {
              historyRes.tcInformation = {};
            }
          } else {
            historyRes = {};
            historyRes.tcInformation = {};
          }
          var oldStatusHistory = [...this.state.statusHistory];
          let sortedStatusHistory = [];
          // Start: Convert UTC time to local time
          if (historyRes) {
            if (orderData.type === 'ChangeSubscription') {
              if (historyRes.packageInstanceBilled) {
                this.setState({
                  packageInstanceBilled: true
                })
              } else {
                this.setState({
                  packageInstanceBilled: false
                })
              }
            }
            historyRes.statusHistory.filter((item) => {
              if (item.orderItemHistory && item.orderItemHistory.length > 0) {
                item.orderItemHistory.sort(
                  (a, b) =>
                    new Date(b.statusChangeTime) - new Date(a.statusChangeTime),
                );
              }
              var hIndex = oldStatusHistory.findIndex(
                (x) => x.orderHistoryId === item.orderHistoryId,
              );
              if (hIndex > -1) {
                if (oldStatusHistory[hIndex].expand) {
                  item.expand = true;
                } else {
                  item.expand = false;
                }
              } else if (
                item.taskDetails &&
                Object.keys(item.taskDetails).length > 0
              ) {
                item.expand = true;
              } else if (
                item.identifiersDetail &&
                item.identifiersDetail.length > 0 &&
                item.orderItemHistory &&
                item.orderItemHistory.length > 0 &&
                item.orderItemHistory[0].statusId !== "ORDER_ITEM_COMPLETED"
              ) {
                item.expand = true;
              } else {
                item.expand = false;
              }
              if (item.statusChangeTime) {
                item.humanDate = formatDate(item.statusChangeTime);
              } else {
                item.humanDate = null;
              }
              if (
                item.taskDetails &&
                item.taskDetails.fields &&
                item.taskDetails.fields.length > 0
              ) {
                var securityGroupsList = this.props.securityGroupsList;
                var tenantData = JSON.parse(localStorage.getItem("roles"));
                var subItemHistory = {};
                if (item.orderItemHistory && item.orderItemHistory.length > 0) {
                  subItemHistory = item.orderItemHistory[0];
                }
                if (
                  subItemHistory.assignedPartyId ||
                  subItemHistory.assignedPartyRole
                ) {
                  // This check is to enable actions for ORDER_MANAGER (Ooredoo specific change)
                  if (
                    subItemHistory.assignedPartyRole &&
                    subItemHistory.assignedPartyRole === "ORDER_MANAGER" &&
                    securityGroupsList.includes("ORDER_MANAGER")
                  ) {
                    item.isEligibleUser = true;
                    item.eligibleRole = "";
                    return;
                  }
                  if (subItemHistory.assignedPartyId) {
                    if (
                      subItemHistory.assignedPartyId ===
                      tenantData.data.loggedInUser.partyId
                    ) {
                      item.isEligibleUser = true;
                      item.eligibleRole = "";
                      return;
                    }
                  }
                  if (subItemHistory.assignedPartyRole) {
                    var isPartnerTask =
                      subItemHistory.assignedPartyRole.includes("PARTNER");
                    if (
                      isPartnerTask &&
                      securityGroupsList.includes("PARTNER_ADMIN")
                    ) {
                      item.isEligibleUser = true;
                      item.eligibleRole = "";
                      return;
                    } else if (
                      !isPartnerTask &&
                      securityGroupsList.includes("ADMIN")
                    ) {
                      item.isEligibleUser = true;
                      item.eligibleRole = "";
                      return;
                    } else if (
                      !subItemHistory.assignedPartyId &&
                      securityGroupsList.includes(
                        subItemHistory.assignedPartyRole,
                      )
                    ) {
                      item.isEligibleUser = true;
                      item.eligibleRole = "";
                      return;
                    }
                  }
                } else {
                  var groupList = item.taskDetails.identityLinks;
                  if (groupList && groupList.length > 0) {
                    var isUserApplicable = groupList.some((g) => g.user);
                    if (isUserApplicable) {
                      item.isEligibleUser = true;
                      item.eligibleRole = "";
                      return;
                    }
                    var isPartnerAction = groupList.some((x) =>
                      x.group.includes("PARTNER"),
                    );
                    if (isPartnerAction) {
                      if (this.props.providerType === "SOLUTION_PROVIDER") {
                      } else {
                        item.isEligibleUser = false;
                        item.eligibleRole = this.snakeToSentenceCase(
                          groupList[0].group,
                        );
                        return;
                      }
                    }
                    if (groupList && groupList.length > 0) {
                      if (securityGroupsList.includes("ADMIN")) {
                        item.isEligibleUser = true;
                        if (groupList && groupList.length > 0) {
                          if (groupList.length === 1) {
                            if (groupList[0].group) {
                              item.eligibleRole = this.snakeToSentenceCase(
                                groupList[0].group,
                              );
                            }
                          } else {
                            for (var i = 0; i < groupList.length; i++) {
                              if (groupList[i].group !== "ADMIN") {
                                if (groupList[i].group) {
                                  item.eligibleRole = this.snakeToSentenceCase(
                                    groupList[i].group,
                                  );
                                }
                                return;
                              }
                            }
                          }
                        }
                      } else {
                        if (groupList && groupList.length > 0) {
                          if (groupList.length === 1) {
                            if (groupList[0].group) {
                              item.eligibleRole = this.snakeToSentenceCase(
                                groupList[0].group,
                              );
                            }
                            var index = securityGroupsList.findIndex(
                              (x) => x === groupList[0].group,
                            );
                            if (index > -1) {
                              item.isEligibleUser = true;
                              return;
                            } else {
                              item.isEligibleUser = false;
                              return;
                            }
                          } else {
                            for (var i = 0; i < groupList.length; i++) {
                              if (groupList[i].group !== "ADMIN") {
                                if (groupList[i].group) {
                                  item.eligibleRole = this.snakeToSentenceCase(
                                    groupList[i].group,
                                  );
                                }
                                return;
                              }
                            }
                            for (var i = 0; i < groupList.length; i++) {
                              var index = securityGroupsList.findIndex(
                                (x) => x === groupList[i].group,
                              );
                              if (index > -1) {
                                item.isEligibleUser = true;
                                return;
                              } else {
                                if (index + 1 === groupList.length) {
                                  item.isEligibleUser = false;
                                  return;
                                }
                              }
                            }
                          }
                        } else {
                          item.isEligibleUser = true;
                          item.eligibleRole = "";
                        }
                      }
                    } else {
                      item.isEligibleUser = true;
                      item.eligibleRole = "";
                    }
                  } else {
                    item.isEligibleUser = true;
                    item.eligibleRole = "";
                  }
                }
              }
            });
            historyRes.subscriptionChangeHistory.filter((item) => {
              if (item.changeTimestamp) {
                item.humanDate = formatDate(item.changeTimestamp);
              } else {
                item.humanDate = null;
              }
            });
            // End: Convert UTC time to local time

            sortedStatusHistory = historyRes.statusHistory.sort((a, b) => {
              return (
                new Date(a.statusChangeTime) - new Date(b.statusChangeTime)
              );
            });

            // console.log('history response', historyRes);
          } else {
            historyRes.statusHistory = [];
            historyRes.subscriptionChangeHistory = [];
          }

          // Order status history items end
          this.setState(
            {
              // customerDetails: custRes.data.customer,
              orderDiscount: orderData.orderDiscount,
              orderId: orderData.orderId,
              orderType: orderData.type,
              orderTypeDescription: orderData.typeDescription,
              originalOrder,
              originalOrderData: orderData,
              orderTotalDiscount: orderData.orderTotalDiscount,
              solutions: [...newSolutions],
              accessories: [...newAccessories],
              customerPartyId: orderData.customerPartyId,
              autoActivatable,
              workFlowEnabled: orderData.workFlowEnabled
                ? orderData.workFlowEnabled
                : false,
              returnOrders: orderData.returns,
              totalRCDiscount: totalRCDiscount,
              totalNRDiscount: totalNRDiscount,
              renderCartBlock: false,
              note: orderData.note ? orderData.note : [],
              externalId: orderData.externalId ? orderData.externalId : "",

              // history status and BPMN process items
              status: orderData.orderStatus,
              orderActivationStatus: orderData.orderActivationStatus,
              processInstanceDiagram: orderData.processInstanceDiagram,
              bpmnProcessInstanceId: orderData.bpmnProcessInstanceId,

              statusHistory: sortedStatusHistory.reverse(),
              subscriptionChangeHistory: historyRes.subscriptionChangeHistory,
              tcInformation: historyRes.tcInformation,
              modify: false,

              customerDetails: custRes.customer,
              tcLinks: tcLinks,
              oldBan: oldBan,
              processingItemData: processingItemData.items,
              orderDate: orderData.orderDate,
            },
            () => {
              this.setState({
                showActionsPanel: true,
                renderCartBlock: true,
                showActions: true,
                show: true,
                loading: false,
                renderActions: true,
              });
              if (this.state.workFlowEnabled) {
                this.getBPMNActions();
              }
            },
          );
        } else {
          this.props.setErrorMessage(
            this.props.t("ORDER_DATA_IS_NOT_READY_ERROR"),
            false,
          );
          this.setState({
            loading: false,
            show: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  filterChildSpecs = (data) => {
    // if (!spec.childSpecs) return spec;

    // // Keep only childSpecs with category === "PSC_CUST_FACING"
    // spec.childSpecs = spec.childSpecs
    //     .filter(child => child.category && child.category.id === 'PSC_CUST_FACING')
    //     .map(child => this.filterChildSpecs(child)); // Recurse!

    // return spec;

    // Base case: if the object has a category and it's not PSC_CUST_FACING
    if (data.category?.id !== "PSC_CUST_FACING") {
      data.chars = [];
    }

    // If there are childSpecs, apply recursively
    if (Array.isArray(data.childSpecs)) {
      data.childSpecs.forEach(this.filterChildSpecs);
    }

    return data;
  };

  updateCategory = (spec) => {
    // If the object has a category and it matches, update it
    if (spec.category && spec.category.id === "Customer Facing") {
      spec.category.id = "PSC_CUST_FACING";
    }

    // If it has childSpecs, process each child recursively
    if (spec.childSpecs && spec.childSpecs.length) {
      spec.childSpecs = spec.childSpecs.map(this.updateCategory);
    }

    return spec;
  };

  getOrderSubscriptions = (ifLoading) => {
    let orderId = this.props.router.params.orderId;
    let customerBan = this.state.orderCustomer.ban;
    let customerClient = this.state.orderCustomer.clientId;

    var pageOptions = {
      batchSize: this.state.subsHistoryPerPage,
      startRecord: this.state.subsHistoryStartRecord,
    };

    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let data = {};
    if (tenantId) {
      data = {
        tenantId: tenantId,
      };
    }
    // this.setState({
    //     subscriptionData: [],
    //     subsHistoryTotalRecords: 0
    // })
    BusApiCall(
      "GET",
      `${constants.busV4Url}/customers/${UriEncode(customerBan)}/client/${customerClient}/subscriptions?sortBy=${this.state.sortBySubs}&sortOrder=${this.state.sortOrderSubs}&productName=&subscriptionId=&orderId=${orderId}`,
      data,
      pageOptions,
    )
      .then((res) => {
        this.setState({
          subscriptionData: res.data.subscriptions,
          subsHistoryTotalRecords: +res.headers["x-total-count"],
        });
        if (ifLoading) {
          this.setState({
            loading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false, searchingSubscriptions: false });
      });
  };

  openSubscription = (subscriptionId) => {
    var subscriptionData = [...this.state.subscriptionData];
    var selectedSubscription = subscriptionData.findIndex(
      (x) => x.subscriptionId === subscriptionId,
    );
    if (selectedSubscription > -1) {
      // if (subscriptionData[selectedSubscription].expand) {
      //   subscriptionData[selectedSubscription].expand = false;
      // } else {
      //   subscriptionData[selectedSubscription].expand = true;
      // }
      // this.setState({ subscriptionData });
      if (
        !subscriptionData[selectedSubscription].expand &&
        !subscriptionData[selectedSubscription].addiotinalDetails
      ) {
        this.setState({
          loading: true,
        });
        let jsonData = {};
        let search = new URLSearchParams(this.props.router.location.search);
        let tenantId = search.get("tenantId");
        if (this.props.providerType === "SOLUTION_PROVIDER") {
          jsonData.tenantId = tenantId;
        }
        BusApiCall(
          "GET",
          `${constants.busV44UrlPublic}/subscriptions/${subscriptionData[selectedSubscription].subscriptionId}`,
          jsonData,
        )
          .then((res) => {
            subscriptionData[selectedSubscription].expand = !subscriptionData[selectedSubscription].expand;
            subscriptionData[selectedSubscription].addiotinalDetails = res.data;
            this.setState({
              subscriptionData,
              loading: false,
            });
          })
          .catch((err) => {
            this.setState({
              subscriptionData,
              loading: false,
            });
            if (err.response && err.response.data && err.response.data.message) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      } else {
        subscriptionData[selectedSubscription].expand = !subscriptionData[selectedSubscription].expand;
        this.setState({
          subscriptionData,
        });
      }
    }


  };

  onSubsHistoryPageChange = (e, page) => {
    this.setState(
      {
        loading: true,
        subsHistoryPage: page,
        subsHistoryStartRecord: this.state.subsHistoryPerPage * (page - 1) + 1,
      },
      () => {
        this.getOrderSubscriptions(true);
      },
    );
  };

  updateSubsHistoryPerPageRows = (event) => {
    this.setState(
      {
        loading: true,
        subsHistoryPage: 1,
        subsHistoryPerPage: event.target.value,
        subsHistoryStartRecord: 1,
      },
      () => {
        this.getOrderSubscriptions(true);
      },
    );
  };

  snakeToSentenceCase = (val) => {
    var a = val;
    var b = val.split("_");
    var d = "";
    if (b.length > 1) {
      var c = b.map((x) => x.toLowerCase());
      d = c.join(" ");
      var e = d.replace(
        /\w\S*/g,
        (text) =>
          text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
      );
      // this.setState({
      //     eligibleRole: e
      // })
      return e;
    } else {
      d = val.toLowerCase();
      var e = d.replace(
        /\w\S*/g,
        (text) =>
          text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
      );
      return e;
      // this.setState({
      //     eligibleRole: e
      // })
    }
  };

  getBPMNActions = () => {
    // Get order id from URL params
    let orderIdUrlParam = this.props.router.params.orderId;
    // this.setState({
    //     loading: true
    // })
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let data = {};
    if (tenantId) {
      data = {
        tenantId: tenantId,
      };
    }
    // var res = {
    //     data: {
    //         "outcomes": [],
    //         "name": "Confirm Installation",
    //         "id": "11143c5e-32b6-11ef-928c-16375c7f29fb",
    //         "fields": [
    //             {
    //                 "name": "Name",
    //                 "overrideId": true,
    //                 "readOnly": false,
    //                 "id": "userName",
    //                 "type": "text",
    //                 "fieldType": "FormField",
    //                 "required": true
    //             },
    //             {
    //                 "name": "Upload",
    //                 "overrideId": false,
    //                 "readOnly": false,
    //                 "id": "upload",
    //                 "type": "upload",
    //                 "fieldType": "FormField",
    //                 "required": false
    //             },
    //             {
    //                 "name": "Please confirms Installation and configuration of IoT sensors on client vehicles.",
    //                 "overrideId": true,
    //                 "readOnly": false,
    //                 "id": "confirmInstallation",
    //                 "type": "boolean",
    //                 "fieldType": "FormField",
    //                 "required": false
    //             },
    //             {
    //                 "readOnly": false,
    //                 "type": "radio-buttons",
    //                 "required": true,
    //                 "name": "Please select the action below to proceed further.",
    //                 "overrideId": true,
    //                 "options": [
    //                     {
    //                         "name": "Approve"
    //                     },
    //                     {
    //                         "name": "Reject"
    //                     }
    //                 ],
    //                 "id": "confirmReview",
    //                 "fieldType": "OptionFormField"
    //             }
    //         ],
    //         "version": 7,
    //         "key": "ConfirmInstallationAndSetupNew",
    //         "taskId": "51f661dd-32b7-11ef-928c-16375c7f29fb"
    //     }
    // }
    // var formFields = res.data;
    // for (var i = 0; i < formFields.fields.length; i++) {
    //     if (formFields.fields[i].type === 'boolean') {
    //         formFields.fields[i].value = true;
    //     }
    //     if (formFields.fields[i].type === 'radio-buttons') {
    //         formFields.fields[i].value = formFields.fields[i].options.length > 0 ? formFields.fields[i].options[0].name : '';
    //     }
    // }
    // console.log('check temp data', formFields)
    // this.setState({
    //     formFields: res.data,
    //     is_order_status: false,

    //     // formFields: formFields,
    //     loading: false
    // })
    // return;
    // Get order actions from flowable
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/orders/${orderIdUrlParam}/flowable/bpmn/taskForms`,
      data,
    )
      .then((res) => {
        var is_order_status =
          res.data.is_order_status &&
            (res.data.is_order_status === true ||
              res.data.is_order_status === "true")
            ? true
            : false;
        if (is_order_status) {
          this.setState({
            order_status_details: res.data.order_status_details,
          });
        }
        var formFields = res.data;
        if (formFields.fields && formFields.fields.length > 0) {
          for (var i = 0; i < formFields.fields.length; i++) {
            if (formFields.fields[i].value) {
              formFields.fields[i].value = null;
            }
          }
        }
        this.setState(
          {
            formFields: formFields,
            is_order_status: is_order_status,

            // formFields: formFields,
            loading: false,
          },
          () => {
            this.checkisEligibleUser();
          },
        );
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };
  checkisEligibleUser = () => {
    this.setState({
      isEligibleUser: false,
      eligibleRole: "",
    });
    var securityGroupsList = this.props.securityGroupsList;
    var currentStatus = this.state.statusHistory[0];
    var tenantData = JSON.parse(localStorage.getItem("roles"));
    if (currentStatus.assignedPartyId || currentStatus.assignedPartyRole) {
      // This check is to enable actions for ORDER_MANAGER (Ooredoo specific change)
      if (
        currentStatus.assignedPartyRole &&
        currentStatus.assignedPartyRole === "ORDER_MANAGER" &&
        securityGroupsList.includes("ORDER_MANAGER")
      ) {
        this.setState({
          isEligibleUser: true,
          eligibleRole: "",
        });
        return;
      }

      if (currentStatus.assignedPartyId) {
        if (
          currentStatus.assignedPartyId === tenantData.data.loggedInUser.partyId
        ) {
          this.setState({
            isEligibleUser: true,
            eligibleRole: "",
          });
          return;
        }
      }
      if (currentStatus.assignedPartyRole) {
        var isPartnerTask = currentStatus.assignedPartyRole.includes("PARTNER");
        if (isPartnerTask && securityGroupsList.includes("PARTNER_ADMIN")) {
          this.setState({
            isEligibleUser: true,
            eligibleRole: "",
          });
          return;
        } else if (!isPartnerTask && securityGroupsList.includes("ADMIN")) {
          this.setState({
            isEligibleUser: true,
            eligibleRole: "",
          });
          return;
        } else if (
          !currentStatus.assignedPartyId &&
          securityGroupsList.includes(currentStatus.assignedPartyRole)
        ) {
          this.setState({
            isEligibleUser: true,
            eligibleRole: "",
          });
          return;
        }
      }
    } else {
      var groupList = this.state.formFields.identityLinks;
      if (groupList && groupList.length > 0) {
        var isUserApplicable = groupList.some((g) => g.user);
        if (isUserApplicable) {
          this.setState({
            isEligibleUser: true,
            eligibleRole: "",
          });
          return;
        }
        var isPartnerAction = groupList.some((x) =>
          x.group.includes("PARTNER"),
        );
        if (isPartnerAction) {
          if (this.props.providerType === "SOLUTION_PROVIDER") {
          } else {
            this.setState({
              isEligibleUser: false,
              eligibleRole: this.snakeToSentenceCase(groupList[0].group),
            });
            return;
          }
        }
        if (securityGroupsList.includes("ADMIN")) {
          this.setState({
            isEligibleUser: true,
          });
          if (groupList && groupList.length > 0) {
            if (groupList.length === 1) {
              if (groupList[0].group) {
                this.snakeToSentenceCase(groupList[0].group);
              }
            } else {
              for (var i = 0; i < groupList.length; i++) {
                if (groupList[i].group !== "ADMIN") {
                  if (groupList[i].group) {
                    this.snakeToSentenceCase(groupList[i].group);
                  }
                  return;
                }
              }
            }
          }
        } else {
          if (groupList && groupList.length > 0) {
            if (groupList.length === 1) {
              if (groupList[0].group) {
                this.snakeToSentenceCase(groupList[0].group);
              }
              var index = securityGroupsList.findIndex(
                (x) => x === groupList[0].group,
              );
              if (index > -1) {
                this.setState({
                  isEligibleUser: true,
                });
                return;
              } else {
                this.setState({
                  isEligibleUser: false,
                });
                return;
              }
            } else {
              for (var i = 0; i < groupList.length; i++) {
                if (groupList[i].group !== "ADMIN") {
                  if (groupList[i].group) {
                    this.snakeToSentenceCase(groupList[i].group);
                  }
                  return;
                }
              }
              for (var i = 0; i < groupList.length; i++) {
                var index = securityGroupsList.findIndex(
                  (x) => x === groupList[i].group,
                );
                if (index > -1) {
                  this.setState({
                    isEligibleUser: true,
                  });
                  return;
                } else {
                  if (index + 1 === groupList.length) {
                    this.setState({
                      isEligibleUser: false,
                    });
                    return;
                  }
                }
              }
            }
          } else {
            this.setState({
              isEligibleUser: true,
              eligibleRole: "",
            });
          }
        }
      } else {
        this.setState({
          isEligibleUser: true,
          eligibleRole: "",
        });
      }
    }
  };
  getOrderAttachments = (id) => {
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let data = {};
    if (tenantId) {
      data = {
        tenantId: tenantId,
      };
    }
    return BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/orders/${id}/attachments`,
      data,
    );
    // BusApiCall('GET', `${constants.busV44UrlPublic}/orders/${id}/attachments`, data).then(res => {
    //     if (res && res.data && res.data.attachments) {
    //         this.setState({
    //             attachments: res.data.attachments,
    //         })
    //     }
    // }).catch(err => {

    // })
  };

  setTempPrice = (price, priceType) => {
    if (typeof price === "object") {
      return price;
    } else {
      let pr = {};
      if (priceType === "RC") {
        pr.recurringPrice = {
          termUomId: null,
          price: price,
        };
      }
      pr.purchasePrice = price;
      return pr;
    }
  };

  getLineItemPrice = (price) => {
    if (typeof price === "object") {
      return price;
    } else {
      // let pr = {};
      // if (priceType === "RC") {
      //     pr.recurringPrice = {
      //         termUomId: null,
      //         price: price,
      //     };
      // }
      // pr.purchasePrice = price;
      return price;
    }
  };

  // this.setState({ showPartialProcessDialog: false, loading: true });
  //         let search = new URLSearchParams(this.props.router.location.search);
  //         let tenantId = search.get("tenantId");
  //         let data = {};
  //         if (tenantId) {
  //             data = {
  //                 "tenantId": tenantId,
  //             }
  //         }
  //         BusApiCall('GET', `${constants.busV44UrlPublic}/orders/${this.state.orderId}/packageOrderItems`, data).then(res => {
  //             console.log('new response', res);
  //             this.setState({
  //                 processingItemData: res.data.items,
  //                 loading: false
  //             })
  //             return true;
  //         }).catch(err => {
  //             if (err.response && err.response.data && err.response.data.message) {
  //                 this.props.setErrorMessage(err.response.data.message, false)
  //             } else {
  //                 console.log("err", err);
  //                 this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
  //             }
  //             this.setState({ loading: false })
  //             return true;
  //         })

  // Get order full history
  getOrderFullHistory = (partial, oldValuesData) => {
    this.setState({ loading: true });
    let orderIdUrlParam = this.props.router.params.orderId;
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let data = {};
    if (tenantId) {
      data = {
        tenantId: tenantId,
      };
    }
    this.setState(
      {
        // status: historyRes.statusHistory[0].statusDisplay,
      },
      () => {
        this.checkOrderForInvoice();
      },
    );
    var urls = [
      BusApiCall(
        "GET",
        `${constants.busV4Url}/orders/${orderIdUrlParam}`,
        data,
      ),
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/orders/${orderIdUrlParam}/history`,
        data,
      ),
      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/orders/${orderIdUrlParam}/flowable/bpmn/taskForms`,
        data,
      ),
    ];
    if (partial) {
      urls.push(
        BusApiCall(
          "GET",
          `${constants.busV44UrlPublic}/orders/${this.state.orderId}/packageOrderItems`,
          data,
        ),
      );
    }

    Promise.all(urls)
      .then((allRes) => {
        let res = allRes[0].data;
        var historyRes = JSON.parse(
          JSON.stringify(allRes[1].data.orderHistory),
        );
        var bpmnRes = allRes[2].data;

        var is_order_status =
          bpmnRes.is_order_status &&
            (bpmnRes.is_order_status === true ||
              bpmnRes.is_order_status === "true")
            ? true
            : false;
        if (is_order_status) {
          this.setState({
            order_status_details: bpmnRes.order_status_details,
          });
        }
        this.getOrderSubscriptions();
        if (res.type === 'ChangeSubscription') {
          if (historyRes.packageInstanceBilled) {
            this.setState({
              packageInstanceBilled: true
            })
          } else {
            this.setState({
              packageInstanceBilled: false
            })
          }
        }
        if (historyRes.tcInformation) {
          if (
            historyRes.tcInformation.actionDate &&
            historyRes.tcInformation.actionDate !== "null"
          ) {
            historyRes.tcInformation.humanDate = formatDate(
              historyRes.tcInformation.actionDate,
              true,
            );
          } else {
            historyRes.tcInformation.humanDate = null;
          }
        } else {
          historyRes.tcInformation = {};
        }
        // Start: Convert UTC time to local time
        var oldStatusHistory = JSON.parse(
          JSON.stringify(this.state.statusHistory),
        );
        historyRes.statusHistory.filter((item) => {
          var hIndex = oldStatusHistory.findIndex(
            (x) => x.orderHistoryId === item.orderHistoryId,
          );
          if (hIndex > -1 && oldStatusHistory[hIndex].expand) {
            item.expand = true;
          } else if (
            item.taskDetails &&
            Object.keys(item.taskDetails).length > 0
          ) {
            item.expand = true;
          } else if (
            item.identifiersDetail &&
            item.identifiersDetail.length > 0 &&
            item.orderItemHistory &&
            item.orderItemHistory.length > 0 &&
            item.orderItemHistory[0].statusId !== "ORDER_ITEM_COMPLETED"
          ) {
            item.expand = true;
          } else {
            item.expand = false;
          }
          if (item.statusChangeTime) {
            item.humanDate = formatDate(item.statusChangeTime);
          } else {
            item.humanDate = null;
          }
          if (
            item.taskDetails &&
            item.taskDetails.fields &&
            item.taskDetails.fields.length > 0
          ) {
            var securityGroupsList = this.props.securityGroupsList;
            var tenantData = JSON.parse(localStorage.getItem("roles"));
            var subItemHistory = {};
            if (item.orderItemHistory && item.orderItemHistory.length > 0) {
              subItemHistory = item.orderItemHistory[0];
            }
            if (
              subItemHistory.assignedPartyId ||
              subItemHistory.assignedPartyRole
            ) {
              if (subItemHistory.assignedPartyId) {
                if (
                  subItemHistory.assignedPartyId ===
                  tenantData.data.loggedInUser.partyId
                ) {
                  item.isEligibleUser = true;
                  item.eligibleRole = "";
                  return;
                }
              }
              if (subItemHistory.assignedPartyRole) {
                var isPartnerTask =
                  subItemHistory.assignedPartyRole.includes("PARTNER");
                if (
                  isPartnerTask &&
                  securityGroupsList.includes("PARTNER_ADMIN")
                ) {
                  item.isEligibleUser = true;
                  item.eligibleRole = "";
                  return;
                } else if (
                  !isPartnerTask &&
                  securityGroupsList.includes("ADMIN")
                ) {
                  item.isEligibleUser = true;
                  item.eligibleRole = "";
                  return;
                } else if (
                  !subItemHistory.assignedPartyId &&
                  securityGroupsList.includes(subItemHistory.assignedPartyRole)
                ) {
                  item.isEligibleUser = true;
                  item.eligibleRole = "";
                  return;
                }
              }
            } else {
              var groupList = item.taskDetails.identityLinks;
              if (groupList && groupList.length > 0) {
                var isUserApplicable = groupList.some((g) => g.user);
                if (isUserApplicable) {
                  item.isEligibleUser = true;
                  item.eligibleRole = "";
                  return;
                }
                var isPartnerAction = groupList.some((x) =>
                  x.group.includes("PARTNER"),
                );
                if (isPartnerAction) {
                  if (this.props.providerType === "SOLUTION_PROVIDER") {
                  } else {
                    item.isEligibleUser = false;
                    item.eligibleRole = this.snakeToSentenceCase(
                      groupList[0].group,
                    );
                    return;
                  }
                }
                if (groupList && groupList.length > 0) {
                  if (securityGroupsList.includes("ADMIN")) {
                    item.isEligibleUser = true;
                    if (groupList && groupList.length > 0) {
                      if (groupList.length === 1) {
                        if (groupList[0].group) {
                          item.eligibleRole = this.snakeToSentenceCase(
                            groupList[0].group,
                          );
                        }
                      } else {
                        for (var i = 0; i < groupList.length; i++) {
                          if (groupList[i].group !== "ADMIN") {
                            if (groupList[i].group) {
                              item.eligibleRole = this.snakeToSentenceCase(
                                groupList[i].group,
                              );
                            }
                            return;
                          }
                        }
                      }
                    }
                  } else {
                    if (groupList && groupList.length > 0) {
                      if (groupList.length === 1) {
                        if (groupList[0].group) {
                          item.eligibleRole = this.snakeToSentenceCase(
                            groupList[0].group,
                          );
                        }
                        var index = securityGroupsList.findIndex(
                          (x) => x === groupList[0].group,
                        );
                        if (index > -1) {
                          item.isEligibleUser = true;
                          return;
                        } else {
                          item.isEligibleUser = false;
                          return;
                        }
                      } else {
                        for (var i = 0; i < groupList.length; i++) {
                          if (groupList[i].group !== "ADMIN") {
                            if (groupList[i].group) {
                              item.eligibleRole = this.snakeToSentenceCase(
                                groupList[i].group,
                              );
                            }
                            return;
                          }
                        }
                        for (var i = 0; i < groupList.length; i++) {
                          var index = securityGroupsList.findIndex(
                            (x) => x === groupList[i].group,
                          );
                          if (index > -1) {
                            item.isEligibleUser = true;
                            return;
                          } else {
                            if (index + 1 === groupList.length) {
                              item.isEligibleUser = false;
                              return;
                            }
                          }
                        }
                      }
                    } else {
                      item.isEligibleUser = false;
                      item.eligibleRole = "";
                    }
                  }
                } else {
                  item.isEligibleUser = true;
                  item.eligibleRole = "";
                }
              } else {
                item.isEligibleUser = true;
                item.eligibleRole = "";
              }
            }
          }
        });
        historyRes.subscriptionChangeHistory.filter((item) => {
          if (item.changeTimestamp) {
            item.humanDate = formatDate(item.changeTimestamp);
          } else {
            item.humanDate = null;
          }
        });
        // End: Convert UTC time to local time

        let sortedStatusHistory = historyRes.statusHistory.sort((a, b) => {
          return new Date(a.statusChangeTime) - new Date(b.statusChangeTime);
        });

        var formFields = bpmnRes;
        if (formFields.fields && formFields.fields.length > 0) {
          for (var i = 0; i < formFields.fields.length; i++) {
            if (formFields.fields[i].value) {
              formFields.fields[i].value = null;
            }
          }
        }

        this.setState(
          {
            status: res.orderStatus,
            orderActivationStatus: res.orderActivationStatus,
            processInstanceDiagram: res.processInstanceDiagram,
            bpmnProcessInstanceId: res.bpmnProcessInstanceId,
            statusHistory: sortedStatusHistory.reverse(),
            subscriptionChangeHistory: historyRes.subscriptionChangeHistory,
            tcInformation: historyRes.tcInformation,
            formFields: formFields,
            is_order_status: is_order_status,
          },
          () => {
            this.checkisEligibleUser();
            if (partial) {
              this.setState(
                {
                  processingItemData: allRes[3].data.items,
                },
                () => {
                  var statusIndex = sortedStatusHistory.findIndex(
                    (x) =>
                      x.orderHistoryId ===
                      this.state.editProcessingItemData.orderHistoryId,
                  );
                  if (statusIndex > -1) {
                    var newValues = sortedStatusHistory[statusIndex];
                    var oldValues = oldValuesData;
                    if (
                      oldValues &&
                      oldValues.identifiersDetail &&
                      oldValues.identifiersDetail.length > 0
                    ) {
                      for (
                        var i = 0;
                        i < oldValues.identifiersDetail.length;
                        i++
                      ) {
                        if (
                          newValues &&
                          newValues.identifiersDetail &&
                          newValues.identifiersDetail.length > 0 &&
                          newValues.identifiersDetail[i]
                        ) {
                          if (
                            newValues.identifiersDetail[i].identifiersDetail &&
                            newValues.identifiersDetail[i].identifiersDetail
                              .length > 0
                          ) {
                            for (
                              var k = 0;
                              k <
                              newValues.identifiersDetail[i].identifiersDetail
                                .length;
                              k++
                            ) {
                              if (
                                oldValues.identifiersDetail[i]
                                  .identifiersDetail[k] &&
                                oldValues.identifiersDetail[i]
                                  .identifiersDetail[k].identifiers &&
                                oldValues.identifiersDetail[i]
                                  .identifiersDetail[k].identifiers.length > 0
                              ) {
                                for (
                                  var j = 0;
                                  j <
                                  oldValues.identifiersDetail[i]
                                    .identifiersDetail[k].identifiers.length;
                                  j++
                                ) {
                                  var iIndex = newValues.identifiersDetail[
                                    i
                                  ].identifiersDetail[k].identifiers.findIndex(
                                    (x) =>
                                      x.name ===
                                      oldValues.identifiersDetail[i]
                                        .identifiersDetail[k].identifiers[j]
                                        .name,
                                  );
                                  if (iIndex > -1) {
                                    if (
                                      newValues.identifiersDetail[i]
                                        .identifiersDetail[k].identifiers[
                                        iIndex
                                      ].value
                                    ) {
                                    } else {
                                      if (
                                        oldValues.identifiersDetail[i]
                                          .identifiersDetail[k].identifiers[
                                          iIndex
                                        ].value
                                      ) {
                                        newValues.identifiersDetail[
                                          i
                                        ].identifiersDetail[k].identifiers[
                                          iIndex
                                        ].value =
                                          oldValues.identifiersDetail[
                                            i
                                          ].identifiersDetail[k].identifiers[
                                            iIndex
                                          ].value;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    this.setState(
                      {
                        editProcessingItemData: newValues,
                        editPartialProcessDialog: false,
                      },
                      () => {
                        this.setState(
                          {
                            editPartialProcessDialog: true,
                          },
                          () => {
                            setTimeout(() => {
                              this.setState({
                                loading: false,
                              });
                            }, 1000);
                          },
                        );
                      },
                    );
                  } else {
                    this.setState({
                      loading: false,
                    });
                  }
                },
              );
            } else {
              this.setState({
                loading: false,
                showActions: true,
              });
            }
          },
        );
        return true;
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          show: false,
        });
        return true;
      });
  };

  // This function is used to get order T&C links
  gettcLinks = () => {
    let orderIdUrlParam = this.props.router.params.orderId;
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let data = {};
    if (tenantId) {
      data = {
        tenantId: tenantId,
      };
    }
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/orders/${orderIdUrlParam}/terms/content`,
      data,
    )
      .then((tcRes) => {
        this.setState({
          tcLinks: tcRes.data.orderTermContentList,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  // This function is used to set order in edit mode
  setEdit = (edit) => {
    this.setState({ edit });
  };

  // This function is used to remove item from axisting order
  removeItem = (index, itemType) => {
    // Remove Packaged Solution
    if (itemType === "SOL") {
      let solutions = [...this.state.solutions];
      solutions.splice(index, 1);
      this.setState({ solutions });
    }
    // Remove Accessory
    else if (itemType === "ACC") {
      let accessories = [...this.state.accessories];
      accessories.splice(index, 1);
      this.setState({ accessories });
    }
  };

  // This function is used to change the quantity of iitems
  changeQuantity = (value, index, itemType, compType, compIndex) => {
    if (value > 0) {
      this.props.setErrorMessage("", false);
      // Since user can only order maximum 999 quantity of an item
      // CHeck for max quantity
      if (value < 1000) {
        // Change Packaged Solution quantity
        if (itemType === "SOL") {
          let solutions = [...this.state.solutions];
          solutions[index].quantity = Math.abs(Math.floor(value));
          this.setState({ solutions });
        }
        // Change  Accessories quantity
        else if (itemType === "ACC") {
          let accessories = [...this.state.accessories];
          accessories[index].quantity = Math.abs(Math.floor(value));
          this.setState({ accessories });
        } else if (itemType === "COMP") {
          // Change quantity of sub  items of packaged soolution
          let solutions = [...this.state.solutions];
          // Chnage addons quantity
          if (compType === "addons") {
            let addons = [...solutions[index].addons];
            addons[compIndex].quantity = Math.abs(Math.floor(value));
            solutions[index].addons = addons;
          } else if (compType === "setup") {
            // Change setup quantity
            let setup = [...solutions[index].setup];
            setup[compIndex].quantity = Math.abs(Math.floor(value));
            solutions[index].setup = setup;
          }
          this.setState({ solutions });
        }
      } else {
        this.props.setErrorMessage(this.props.t('Max Items Error"'), false);
      }
    }
  };

  // Change accessories price
  changeAccPrice = (value, index) => {
    if (value === null || value < 0.1) {
      let accessories = [...this.state.accessories];
      accessories[index].price = 0.1;
      accessories[index].overridePrice = "Y";
      this.setState({ accessories });
    } else {
      let accessories = [...this.state.accessories];
      accessories[index].price = +value;
      accessories[index].overridePrice = "Y";
      this.setState({ accessories });
    }
  };

  // Add new item in existing order
  // But user can only able to do that before accept T&C email
  addItem = (sol = null, acc = []) => {
    this.setState({ loading: true });
    // If item is packaged soltuion
    let solutions = [...this.state.solutions];
    if (sol) {
      // If there is any selected promo then check for same BAN
      if (sol.promoId) {
        this.setState({ loading: true });
        // Get promo BAN
        BusApiCall(
          "GET",
          `${constants.busInternalUrl}/promos/${sol.promoId}`,
        ).then((res) => {
          // If order BAN and selected solution BAN is same then add Packaged solution
          if (this.state.oldBan === res.data.promoCustomerList[0].partyId) {
            solutions.push({ ...sol });
          } else {
            // Else show error
            this.props.setErrorMessage(
              this.props.t(
                "CANNOT_SELECT_A_SPECIAL_PRICING_FOR_MULTIPLE_CUSTOMER_BANS_AT_THE_SAME_TIME",
              ),
            );
          }
          this.setState({ loading: false });
        });
      } else {
        // If promo is not selected then add packaged solution
        solutions.push({ ...sol });
      }
    }
    // If item is accessory
    let accessories = [...this.state.accessories];
    let newAcc = [...acc];
    for (let i = 0; i < newAcc.length; i++) {
      if (newAcc[i].id) {
        let index = accessories.findIndex(
          (a) =>
            a.id === newAcc[i].id &&
            a.packageSolutionId === newAcc[i].packageSolutionId,
        );
        if (index > -1) {
          accessories[index].quantity += newAcc[i].quantity;
        } else {
          accessories.push({ ...newAcc[i] });
        }
      } else {
        accessories.push({ ...newAcc[i] });
      }
    }
    this.setState({
      loading: false,
      solutions,
      accessories,
    });
    this.props.router.navigate(`/order/${this.props.router.params.orderId}`);
  };

  // This function is used to check user action selection
  selectAction = (action) => {
    if (action === "modifyOrder") {
      this.setState({
        modify: true,
      });
    } else if (action === "resendMail") {
      this.setState({ isMailDialog: true });
    } else if (action === "activateOrder") {
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        let search = new URLSearchParams(this.props.router.location.search);
        let tenantId = search.get("tenantId");
        this.props.router.navigate(
          `/activate/${this.state.orderId}?tenantId=${tenantId}`,
        );
      } else {
        this.props.router.navigate(`/activate/${this.state.orderId}`);
      }
    } else if (action === "cancelOrder") {
      this.setState({ isCancelDialog: true });
    }
  };

  // Cancel update order
  cancelModify = () => {
    this.setState({
      accessories: JSON.parse(this.state.originalOrder).accessories,
      solutions: JSON.parse(this.state.originalOrder).solutions,
      modify: false,
      edit: {
        quantity: false,
        item: false,
        price: false,
      },
    });
  };

  // Update order data
  updateOrder = () => {
    this.setState({ loading: true, msg: "" });
    const originalCart = JSON.parse(this.state.originalOrder);
    const originalSolutions = originalCart.solutions;
    let currentSolutions = this.state.solutions;
    let newCart = { solutions: [], accessories: [] };

    // checking changes in old Sol
    // If solution got updated set 'changeType' to 'edit'
    // If solution got removed set 'changeType' to 'remove'
    if (originalSolutions && originalSolutions.length > 0) {
      for (let i = 0; i < originalSolutions.length; i++) {
        let index = currentSolutions.findIndex(
          (a) => a.index === originalSolutions[i].index,
        );
        if (index > -1) {
          if (originalSolutions[i].addOnQuantMod) {
            let updatedSolution = { ...currentSolutions[index] };
            let updatedaddons = [];
            let updatedSetup = [];
            // If addons quantity got updated
            if (originalSolutions[i].addons) {
              for (let a = 0; a < originalSolutions[i].addons.length; a++) {
                if (
                  originalSolutions[i].addons[a].quantity !==
                  currentSolutions[i].addons[a].quantity
                ) {
                  updatedaddons.push({
                    ...currentSolutions[i].addons[a],
                    changeType: "edit",
                    oldQty: originalSolutions[i].addons[a].quantity,
                  });
                }
              }
              updatedSolution.addons = [...updatedaddons];
            }
            // If setup quantity got updated
            if (originalSolutions[i].setup) {
              for (let a = 0; a < originalSolutions[i].setup.length; a++) {
                if (
                  originalSolutions[i].setup[a].quantity !==
                  currentSolutions[i].setup[a].quantity
                ) {
                  updatedSetup.push({
                    ...currentSolutions[i].setup[a],
                    changeType: "edit",
                    oldQty: originalSolutions[i].setup[a].quantity,
                  });
                }
              }
              updatedSolution.setup = [...updatedSetup];
            }
            newCart.solutions.push({
              ...updatedSolution,
              changeType: "edit",
              oldQty: null,
            });
          }

          // If packaged solution quantity got updated
          if (
            currentSolutions[index].quantity !== originalSolutions[i].quantity
          ) {
            newCart.solutions.push({
              ...currentSolutions[index],
              index: originalSolutions[i].index,
              changeType: "edit",
              oldQty: originalSolutions[i].quantity,
            });
          }
        } else {
          // If item got removed from order
          newCart.solutions.push({
            ...originalSolutions[i],
            index: originalSolutions[i].index,
            changeType: "remove",
            oldQty: originalSolutions[i].quantity,
          });
        }
      }
    }

    // check for new added packaged solutions
    for (let i = 0; i < currentSolutions.length; i++) {
      if (typeof currentSolutions[i].index === "undefined") {
        newCart.solutions.push({
          ...currentSolutions[i],
          changeType: "new",
        });
      }
    }

    // getting all Accessories
    const originalAccessories = originalCart.accessories;
    let currentAccessories = this.state.accessories;
    if (originalAccessories && originalAccessories.length > 0) {
      for (let i = 0; i < originalAccessories.length; i++) {
        let index = currentAccessories.findIndex(
          (a) => a.id === originalAccessories[i].id,
        );
        if (index > -1) {
          // If accessory quantity got updated
          if (
            originalAccessories[i].quantity !==
            currentAccessories[index].quantity ||
            originalAccessories[i].price !== currentAccessories[index].price
          ) {
            currentAccessories[index].changeType = "edit";
            currentAccessories[index].oldQty = originalAccessories[i].quantity;
            newCart.accessories.push({
              ...currentAccessories[index],
            });
          }
        } else {
          // If accessory got removed from order
          newCart.accessories.push({
            ...originalAccessories[i],
            changeType: "remove",
          });
        }
      }
    }
    // checking for new Accessories
    for (let i = 0; i < currentAccessories.length; i++) {
      let index = originalAccessories.findIndex(
        (a) => a.id === currentAccessories[i].id,
      );
      if (index < 0) {
        newCart.accessories.push({
          ...currentAccessories[i],
          changeType: "new",
        });
      }
    }

    let finalCart = newCart;
    finalCart.orderId = this.state.orderId;
    // Send updated order to API
    BusApiCall(
      "PUT",
      `${constants.busInternalUrl}/orders/${this.state.orderId}`,
      finalCart,
    )
      .then((res) => {
        this.setState({
          modify: false,
          loading: false,
        });
        this.props.setErrorMessage(
          this.props.t("ORDER_MODIFIED_SUCCESSFULLY"),
          true,
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
    this.setState({
      edit: {},
    });
  };

  // Update order contact details
  updateCustomerDetails = () => {
    this.props.router.navigate(
      `${this.props.router.location.pathname}/contact`,
    );
  };
  // Close resend T&C email modal
  closeMailDialog = () => {
    this.setState({ isMailDialog: false });
  };
  // Close cancel order dialog
  closeCancelDialog = (val) => {
    if (val) {
      this.getOrderFullHistory();
    }
    this.setState({ isCancelDialog: false });
  };
  // Close error message
  showCustomerBanError = (error, type) => {
    this.props.setErrorMessage(error, type);
  };

  // Covert base64 to array buffer
  base64ToArrayBuffer = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };

  downloadAttchemnt = (item) => {
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let data = {};
    if (tenantId && this.props.providerType === "SOLUTION_PROVIDER") {
      data = {
        tenantId: tenantId,
      };
    }
    let base64 = null;
    let mimeType = null;
    let name = null;
    this.setState({ loading: true });
    BusApiCall("GET", `${constants.busV44UrlPublic}/orders/${this.state.orderId}/attachments/contents/${item.contentId}`, data)
      .then((res) => {
        base64 = res?.data?.attachments?.[0]?.attachment ?? res?.data?.base64 ?? res?.data?.attachment ?? "";
        mimeType = res?.data?.mimeType ?? item?.mimeType ?? "";
        name = res?.data?.name ?? item?.name ?? "";

        if (!base64 || !mimeType || !name) {
          this.props.setErrorMessage(this.props.t("PROBLEM_DOWNLOADING_FILE"), false);
          this.setState({ loading: false });
          return;
        }

        if (mimeType === "application/pdf") {
          const arrayBuffer = this.base64ToArrayBuffer(base64.replace("data:application/pdf;base64,", ""));
          const blob = new Blob([arrayBuffer], { type: "application/pdf" }, name);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = name;
          link.dispatchEvent(new MouseEvent("click"));
          window.URL.revokeObjectURL(url);
        } else {
          const a = document.createElement("a");
          a.href = "data:" + mimeType + ";base64," + base64;
          a.download = name;
          a.dispatchEvent(new MouseEvent("click"));
        }

        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log("err", err);
        this.setState({ loading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(this.props.t("PROBLEM_DOWNLOADING_FILE"), false);
        }
      })
  };
  editVisibility = (item, visibility) => {
    var payload = {
      id: item.contentId,
      document: {
        isPublic: visibility,
      },
    };
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/orders/${this.state.orderId}/attachments`,
      payload,
    )
      .then((res) => {
        this.props.setErrorMessage(
          this.props.t("DOCUMENT_VISIBILITY_UPDATED", {
            documentName: item.name,
            visibility:
              visibility === "Y"
                ? this.props.t("PUBLIC")
                : this.props.t("PRIVATE"),
          }),
          true,
        );

        // Get order attachments- after updating visibility
        this.getOrderAttachments(this.state.orderId)
          .then((res) => {
            if (res && res.data && res.data.attachments) {
              this.setState({
                attachments: res.data.attachments,
              });
            }
          })
          .catch((err) => {
            console.error("Error fetching attachments:", err);
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      })
      .catch((err) => {
        console.log("err", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DOCUMENT_VISIBILITY_UPDATED_ERROR", {
              documentName: item.name,
            }),
            false,
          );
        }
      });
  };

  // Download T&C pdf
  downloadPdf = (term) => {
    this.setState({
      loading: true,
    });

    let data = {
      termText: term.termText,
      termUrl: term.termsUrl,
    };

    // Get PDF link
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/orders/${this.state.orderId}/terms/content`,
      data,
    )
      .then((res) => {
        this.setState({
          loading: false,
        });

        // Convert pdf to array buffer
        var arrrayBuffer = this.base64ToArrayBuffer(res.data.pdfData);
        // Create pdf blob
        var blob = new Blob(
          [arrrayBuffer],
          { type: "application/pdf" },
          res.data.termText,
        );
        // Create URL object and download
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = term.termText + ".pdf";
        link.dispatchEvent(new MouseEvent("click"));
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  // Download invoive pdf
  downloadInvoicePdf = () => {
    this.setState({
      loading: true,
    });
    let orderIdUrlParam = this.props.router.params.orderId;
    // Get PDF link
    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders/${orderIdUrlParam}/invoice/${this.state.invoiceId}`,
    )
      .then((res) => {
        this.setState({
          loading: false,
        });

        // Convert pdf to array buffer
        var arrrayBuffer = this.base64ToArrayBuffer(res.data.invoicePdf);
        // Create pdf blob
        var blob = new Blob(
          [arrrayBuffer],
          { type: "application/pdf" },
          res.data.invoicePdf,
        );
        // Create URL object and download
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = orderIdUrlParam + "-invoice.pdf";
        link.dispatchEvent(new MouseEvent("click"));
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  updateOrderStatus = (note) => {
    this.setState({ loading: true });
    let orderIdUrlParam = this.props.router.params.orderId;
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    // let data = {
    //     action: 'updateStatus',
    //     orderId: orderIdUrlParam,
    //     note: note,
    //     "tenantId": tenantId,
    // }
    let data = {
      statusId: note,
    };
    // BusApiCall('PUT', `${constants.busInternalUrl}/orders/${orderIdUrlParam}`, data).then(res => {
    BusApiCall(
      "PUT",
      `${constants.busV44UrlPublic}/orders/${orderIdUrlParam}/updateStatus`,
      data,
    )
      .then((res) => {
        this.props.setErrorMessage(
          this.props.t("ORDER_UPDATED_SUCCESSFULLY"),
          true,
        );
        // setTimeout(() => {
        this.getOrderFullHistory();
        // }, 5000)
        this.setState({
          orderUpdateDate: new Date(),
          showActions: false,
          // loading: false
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  displayActionBlock() {
    // return (this.state.status === 'Review to be Completed');
    return true;
  }

  invoiceOrder = () => {
    this.setState({
      disableInvoiceBtn: true,
      loading: true,
    });
    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders/${this.state.orderId}/invoice`,
    )
      .then((res) => {
        this.props.setErrorMessage(
          this.props.t("INVOICE_INITIATED_SUCCESSFULLY"),
          true,
        );
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  showActionDialog = (actionStatus) => {
    this.setState(
      {
        actionDialog: true,
        actionStatus:
          actionStatus && actionStatus === "VERIFY_ODR_PAYMENT"
            ? actionStatus
            : "",
      },
      () => { },
    );
  };

  closeActionDialog = (val) => {
    if (val) {
      this.setState({
        loading: true,
      });
      val.properties.push({
        id: "accessToken",
        value: this.props.accessToken,
      });
      val.properties.push({
        id: "customerBan",
        value: this.state.originalOrderData.customer.ban,
      });
      if (val.uploadedFilesData && val.uploadedFilesData.length > 0) {
        var uploadedFilesData = [];
        for (var i = 0; i < val.uploadedFilesData.length; i++) {
          var fileItem = {
            document: [
              {
                id: "upload",
                value: val.uploadedFilesData[i].fileData,
              },
              {
                id: "uploadedFileName",
                value: val.uploadedFilesData[i].uploadedFileName,
              },
              {
                id: "uploadedFileMimeType",
                value: val.uploadedFilesData[i].uploadedFileMimeType,
              },
              {
                id: "uploadedFileTaskId",
                value: val.uploadedFilesData[i].uploadedFileTaskId,
              },
              {
                id: "isPublic",
                value: val.uploadedFilesData[i].isPublic ? "Y" : "N",
              },
            ],
          };
          uploadedFilesData.push(fileItem);
          if (i === val.uploadedFilesData.length - 1) {
            val.properties.push({
              id: "uploadedFiles",
              value: JSON.stringify(uploadedFilesData),
            });
          }
        }
      }
      // for (var i = 0; i < val.properties.length; i++) {
      //     if (val.properties[i].fileData) {
      //         val.properties[i].value = val.properties[i].fileData;
      //         delete val.properties[i].fileData;
      //     }
      // }
      let search = new URLSearchParams(this.props.router.location.search);
      let tenantId = search.get("tenantId");
      if (this.state.is_order_status) {
        var payload = {};
        payload = val;
        if (tenantId) {
          payload.tenantId = tenantId;
        }
        // payload = {
        //     [val.properties[0].id]: val.properties[0].value
        // }
        BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/flowable/bpmn/resumeDeadProcess?processInstanceId=${this.state.formFields.processInstanceId}`,
          payload,
        )
          .then((res) => {
            this.setState(
              {
                actionDialog: false,
                loading: false,
                actionStatus: "",
              },
              () => {
                this.getFullOrderDetails();
              },
            );
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              console.log("err", err);
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ loading: false });
          });
      } else {
        if (tenantId) {
          val.tenantId = tenantId;
        }
        if (val.uploadedFilesData) {
          delete val.uploadedFilesData;
        }
        var uploadIndex = val.properties.findIndex((x) => x.id === "upload");
        if (uploadIndex > -1) {
          val.properties.splice(uploadIndex, 1);
        }
        BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/flowable/bpmn/taskForms`,
          val,
        )
          .then((res) => {
            this.setState(
              {
                actionDialog: false,
                loading: false,
                actionStatus: "",
              },
              () => {
                this.getFullOrderDetails();
              },
            );
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              console.log("err", err);
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ loading: false });
          });
      }
    } else {
      this.setState({
        actionDialog: false,
        actionStatus: "",
      });
    }
  };

  closeChildActionDialog = (val) => {
    console.log("check child val", val, this.state.is_order_status);
    if (val && val.taskId) {
      this.setState({
        loading: true,
      });
      val.properties.push({
        id: "accessToken",
        value: this.props.accessToken,
      });
      val.properties.push({
        id: "customerBan",
        value: this.state.originalOrderData.customer.ban,
      });
      if (val.uploadedFilesData && val.uploadedFilesData.length > 0) {
        var uploadedFilesData = [];
        for (var i = 0; i < val.uploadedFilesData.length; i++) {
          var fileItem = {
            document: [
              {
                id: "upload",
                value: val.uploadedFilesData[i].fileData,
              },
              {
                id: "uploadedFileName",
                value: val.uploadedFilesData[i].uploadedFileName,
              },
              {
                id: "uploadedFileMimeType",
                value: val.uploadedFilesData[i].uploadedFileMimeType,
              },
              {
                id: "uploadedFileTaskId",
                value: val.uploadedFilesData[i].uploadedFileTaskId,
              },
              {
                id: "isPublic",
                value: val.uploadedFilesData[i].isPublic ? "Y" : "N",
              },
            ],
          };
          uploadedFilesData.push(fileItem);
          if (i === val.uploadedFilesData.length - 1) {
            val.properties.push({
              id: "uploadedFiles",
              value: JSON.stringify(uploadedFilesData),
            });
          }
        }
      }
      // for (var i = 0; i < val.properties.length; i++) {
      //     if (val.properties[i].fileData) {
      //         val.properties[i].value = val.properties[i].fileData;
      //         delete val.properties[i].fileData;
      //     }
      // }
      let search = new URLSearchParams(this.props.router.location.search);
      let tenantId = search.get("tenantId");
      if (tenantId) {
        val.tenantId = tenantId;
      }
      delete val.uploadedFilesData;
      var uploadIndex = val.properties.findIndex((x) => x.id === "upload");
      if (uploadIndex > -1) {
        val.properties.splice(uploadIndex, 1);
      }
      BusApiCall(
        "POST",
        `${constants.busV44UrlPublic}/flowable/bpmn/taskForms`,
        val,
      )
        .then((res) => {
          this.setState(
            {
              selectedChildProcessData: {},
              showChildActionDailog: false,
              actionStatus: "",
              loading: false,
            },
            () => {
              this.getFullOrderDetails();
            },
          );
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            console.log("err", err);
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            selectedChildProcessData: {},
            showChildActionDailog: false,
            actionStatus: "",
          });
        });
    } else {
      this.setState({
        selectedChildProcessData: {},
        showChildActionDailog: false,
        actionStatus: "",
      });
    }
  };

  openDiagramDialog = () => {
    window.open(
      `${window.location.origin}/diagram.html?baseUrl=${constants.busV4Url}&bpmnProcessInstanceId=${this.state.bpmnProcessInstanceId}&orderId=${this.state.orderId}&type=order&tenantId=${this.props.tenantInfo.tenantId}`,
      "_blank",
    );
  };

  openHistoryDiagramDialog = (item) => {
    window.open(
      `${window.location.origin}/diagram.html?baseUrl=${constants.busInternalUrl}&bpmnProcessInstanceId=${item.bpmnProcessInstanceId}&orderId=${this.state.orderId}&type=orderHistory&tenantId=${this.props.tenantInfo.tenantId}&orderHistoryId=${item.orderHistoryId}`,
      "_blank",
    );
  };

  getExtension = () => {
    var extension = "";
    let decoded = atob(this.state.processInstanceDiagram);
    var lowerCase = decoded.toLowerCase();
    if (lowerCase.indexOf("png") === 1) {
      extension = "png";
    } else if (
      lowerCase.indexOf("jpg") === 1 ||
      lowerCase.indexOf("jpeg") === 1
    ) {
      extension = "jpg";
    } else if (lowerCase.includes("svg")) {
      extension = "svg+xml";
    } else if (
      lowerCase.indexOf("tif") === 1 ||
      lowerCase.indexOf("tiff") === 1
    ) {
      extension = "tiff";
    }
    return extension;
  };

  clearCustomer = (itemSequence, customerId) => {
    var items = [...this.state.orderItemLocations];
    if (items.length > 0) {
      var index = items.findIndex((x) => x.orderItemSeqId === itemSequence);
      if (index > -1) {
        items.splice(index, 1);
      }
    }
    this.setState({
      orderItemLocations: items,
    });
  };

  editCustomer = (itemSequence, customerId) => {
    var items = [...this.state.orderItemLocations];
    if (items.length > 0) {
      var index = items.findIndex((x) => x.orderItemSeqId === itemSequence);
      if (index > -1) {
        items[index].location = customerId;
      }
    }
    this.setState({
      orderItemLocations: items,
    });
  };

  updateLineItemClient = (packageId, productId, customerId, action) => {
    var payload = [
      {
        packageId: packageId,
        packageProductId: productId,
        location: customerId,
        action: action,
      },
    ];
    this.setState({
      loading: true,
    });
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/orders/${this.state.orderId}/locations`,
      payload,
    )
      .then((orderRes) => {
        this.setState(
          {
            loading: false,
          },
          () => {
            this.getFullOrderDetails();
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  toggleCustomerOrderNumberDailog = (val) => {
    this.setState({
      tempExternalId: val,
      showCustomerOrderNumberDialog: !this.state.showCustomerOrderNumberDialog,
    });
  };

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  inputAlphaNumeric = (e, callback) => {
    if (e.target.value.length < 21) {
      const value = e.target.value
        ? e.target.value.replace(/[^0-9a-zA-Z -]+/gi, "")
        : "";
      if (e.target.value !== value) {
        e.target.value = value;
      }
      if (typeof callback === "function") {
        return callback(value);
      }
    }
  };

  updateCustomerOrderNumber = () => {
    if (this.state.tempExternalId) {
      this.setState({
        loading: true,
      });
      var payload = {
        // "priority": this.state.originalOrderData.priority,
        externalId: this.state.tempExternalId,
        // "action": false,
        // "description": "Order for enterprise.",
        // "note": this.state.originalOrderData.note,
        // "agreement": [ // if existing
        //     {
        //         "id": "3029304",
        //         "name": "Digitize Solution Aggrement"
        //     }
        // ],
      };
      console.log("this.state", this.state.originalOrderData);
      BusApiCall(
        "PATCH",
        `${constants.busV44UrlPublic}/orders/${this.state.orderId}`,
        payload,
      )
        .then((res) => {
          this.setState({
            tempExternalId: "",
            externalId: payload.externalId,
            loading: false,
            showCustomerOrderNumberDialog: false,
          });
          console.log("check response", res);
          // this.getFullOrderDetails();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            console.log("err", err);
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    }
  };

  togglePrtialProcessingDailog = (val) => {
    if (val) {
      this.setState({ showPartialProcessDialog: false, loading: true });
      let search = new URLSearchParams(this.props.router.location.search);
      let tenantId = search.get("tenantId");
      let data = {};
      if (tenantId) {
        data = {
          tenantId: tenantId,
        };
      }
      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/orders/${this.state.orderId}/packageOrderItems`,
        data,
      )
        .then((res) => {
          console.log("new response", res);
          this.setState({
            processingItemData: res.data.items,
            loading: false,
          });
          return true;
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            console.log("err", err);
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
          return true;
        });
    } else {
      this.setState({
        showPartialProcessDialog: !this.state.showPartialProcessDialog,
      });
    }
  };

  toggleChildProcessDialog = (val) => {
    if (val) {
      this.setState(
        {
          selectedChildProcessData: val,
          actionStatus:
            val.orderItemHistory.length > 0 &&
              val.orderItemHistory[0].statusId === "VERIFY_ODR_PAYMENT"
              ? val.orderItemHistory[0].statusId
              : "",
        },
        () => {
          this.setState({
            showChildActionDailog: true,
          });
        },
      );
    } else {
      this.setState({
        selectedChildProcessData: {},
        showChildActionDailog: false,
        actionStatus: "",
      });
    }
  };

  expandChildProcess = (item, index) => {
    var data = this.state.statusHistory;
    data[index].expand = !data[index].expand;
    this.setState({
      statusHistory: data,
    });
  };

  editProcessData = (item) => {
    console.log("check item data", item);
    this.setState({
      editProcessingItemData: item,
      editPartialProcessDialog: true,
    });
  };

  toggleEditPrtialProcessingDailog = (val) => {
    if (val) {
      this.setState(
        {
          editProcessingItemData: {},
          editPartialProcessDialog: false,
        },
        () => {
          this.getOrderFullHistory();
        },
      );
    } else {
      this.setState({
        editProcessingItemData: {},
        editPartialProcessDialog: false,
      });
    }
  };

  reloadPartialOrderProcessingData = (oldValues) => {
    this.getOrderFullHistory(true, oldValues);
  };

  changeNotes = (e) => {
    this.setState({
      notes: e.target.value,
    });
  };
  confirmNote = (note) => {
    if (!this.state.notes) {
      this.props.setErrorMessage(this.props.t("NO_NOTE_ADDED"), false);
    } else {
      this.setState({
        loading: true,
      });
      let search = new URLSearchParams(this.props.router.location.search);
      let tenantId = search.get("tenantId");
      var payload = {
        tenantId: tenantId,
        note: [
          {
            text: this.state.notes,
          },
        ],
      };

      if (
        this.state.solutions &&
        this.state.solutions.length > 0 &&
        this.state.solutions[0].id
      ) {
        BusApiCall(
          "PATCH",
          `${constants.busV44UrlPublic}/orders/${this.state.orderId}`,
          payload,
        )
          .then((res) => {
            if (note) {
              this.props.setErrorMessage(
                this.props.t("NOTE_ADDED_SUCCESSFULLY"),
                true,
              );
            }
            this.setState({
              notes: "",
            });
            this.getFullOrderDetails();
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              console.log("err", err);
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      }
      this.setState({
        loading: false,
      });
    }
  };
  openUploadAttachmentDialog = () => {
    this.setState({
      showUploadDailog: true,
    });
  };
  onChangeAssesment = (e) => {
    var tempAssessment = { ...this.state.assessmentData };
    tempAssessment.name = e.target.value;
    var error = { ...this.state.uploadAssesmentError };
    error.show = false;
    this.setState({
      uploadAssesmentError: error,
      assessmentData: tempAssessment,
    });
  };
  onDocumentUpload = (event) => {
    // let format = event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf('.') + 1).toLowerCase();
    // let itemType = event.target.files[0].type;
    // let fileSize = event.target.files[0].size;
    const files = Array.from(event.target.files);
    const filesData = [];
    let hasError = false;
    for (let selectedFile of files) {
      let format = selectedFile.name
        .substring(selectedFile.name.lastIndexOf(".") + 1)
        .toLowerCase();
      let itemType = selectedFile.type;
      let fileSize = selectedFile.size;
      if (fileSize > 5242880) {
        var error = { ...this.state.uploadAssesmentError };
        error.show = true;
        error.msg =
          event.target.files[0].name + " " + this.props.t("LARGE_FILE_ERROR");
        this.setState({
          uploadAssesmentError: error,
        });
        hasError = true;
        return;
      }
      // if (format === 'pdf' || format === 'jpg' || format === 'jpeg' || format === 'png') {
      //     var error = { ...this.state.uploadAssesmentError };
      //     error.show = false;
      //     this.setState({
      //         uploadAssesmentError: error
      //     })
      //     this.setState({
      //         loading: true
      //     })
      //     let selectedFile = event.target.files;
      //     let file = null;
      //     let fileName = "";
      //     //Check File is not Empty
      //     if (selectedFile.length > 0) {
      //         // Select the very first file from list
      //         let fileToLoad = selectedFile[0];
      //         fileName = fileToLoad.name;
      //         // FileReader function for read the file.
      //         let fileReader = new FileReader();
      //         // Onload of file read the file content
      //         fileReader.onload = function (fileLoadedEvent) {
      //             var tempFile = fileLoadedEvent.target.result;
      //             file = tempFile.split(',')[1];
      //         };
      //         // Convert data to base64
      //         fileReader.readAsDataURL(fileToLoad);
      //     }
      //     setTimeout(() => {
      //         var tempAssessment = { ...this.state.assessmentData };
      //         tempAssessment.data = file;
      //         tempAssessment.fileName = fileName;
      //         tempAssessment.format = itemType;
      //         this.setState({
      //             assessmentData: tempAssessment,
      //             loading: false
      //         })
      //     }, 2000)
      if (
        format === "pdf" ||
        format === "jpg" ||
        format === "jpeg" ||
        format === "png"
      ) {
        filesData.push({
          file: selectedFile,
          format: itemType,
          fileName: selectedFile.name,
          isPublic:
            this.props.providerType === "SALES_CHNL_PROVIDER" ? "N" : "Y",
        });
      } else {
        var error = { ...this.state.uploadAssesmentError };
        error.show = true;
        error.msg = this.props.t("INVALID_FILE_FORMAT");
        this.setState({
          uploadAssesmentError: error,
        });
        hasError = true;
      }
    }
    if (!hasError) {
      var error = { ...this.state.uploadAssesmentError };
      error.show = false;
      this.setState({
        uploadAssesmentError: error,
        loading: true,
      });
      Promise.all(
        filesData.map((fileData) => {
          return new Promise((resolve) => {
            let fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
              resolve({
                data: fileLoadedEvent.target.result.split(",")[1],
                fileName: fileData.fileName,
                format: fileData.format,
                isPublic: fileData.isPublic,
              });
            };
            fileReader.readAsDataURL(fileData.file);
          });
        }),
      ).then((results) => {
        var tempAssessment = { ...this.state.assessmentData };
        tempAssessment.files = results;
        tempAssessment.fileName = results.map((r) => r.fileName);
        this.setState({
          assessmentData: tempAssessment,
          loading: false,
        });
      });
      // } else {
      //     var error = { ...this.state.uploadAssesmentError };
      //     error.show = true;
      //     error.msg = this.props.t('INVALID_FILE_FORMAT');
      //     this.setState({
      //         uploadAssesmentError: error
      //     })
    }
  };

  // uploadAssessment = () => {
  //     if (this.state.assessmentData.data && this.state.assessmentData.name) {
  //         var payload = {};
  //         payload.document = {
  //             data: this.state.assessmentData.data,
  //             format: this.state.assessmentData.format,
  //             name: this.state.assessmentData.name,
  //             description: '',
  //             isPublic: this.props.providerType === 'SALES_CHNL_PROVIDER' ? 'N' : 'Y'
  //         }
  //         let search = new URLSearchParams(this.props.router.location.search);
  //         let tenantId = search.get("tenantId");
  //         if (tenantId && this.props.providerType !== 'SALES_CHNL_PROVIDER') {
  //             payload.tenantId = tenantId;
  //         }
  //         if (this.state.attachments && this.state.attachments.length > 0) {
  //             var isDuplicateFile = this.state.attachments.some(x => x.name.toLowerCase() === this.state.assessmentData.name.toLowerCase());
  //             if (isDuplicateFile) {
  //                 var error = { ...this.state.uploadAssesmentError };
  //                 error.show = true;
  //                 error.msg = this.props.t('DUPLICATE_ATTACHMENT_NAME');
  //                 this.setState({
  //                     uploadAssesmentError: error
  //                 })
  //                 return;
  //             }
  //         }
  //         this.setState({
  //             loading: true,
  //             showUploadDailog: false,
  //         })
  //         BusApiCall('POST', `${constants.busV44UrlPublic}/orders/${this.state.orderId}/attachment`, payload).then(res => {
  //             BusApiCall('GET', `${constants.busV44UrlPublic}/orders/${this.state.orderId}/attachments`, payload).then(res => {
  //                 if (res && res.data && res.data.attachments) {
  //                     this.setState({
  //                         attachments: res.data.attachments,
  //                         loading: false
  //                     })
  //                 }
  //             }).catch(err => {

  //             })
  //             this.props.setErrorMessage(this.props.t('DOCUMENT_UPLOADED_SUCCESSFULLY'), true);
  //             this.setState({
  //                 assessmentData: {
  //                     name: '',
  //                     data: '',
  //                     format: '',
  //                     fileName: ''
  //                 },
  //                 showUploadDailog: false
  //                 // loading: false
  //             })
  //         }).catch(err => {
  //             if (err.response && err.response.data && err.response.data.message) {
  //                 this.props.setErrorMessage(err.response.data.message, false)
  //             } else {
  //                 this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
  //             }
  //             this.setState({
  //                 loading: false,
  //                 showUploadDailog: false,
  //                 assessmentData: {
  //                     name: '',
  //                     data: '',
  //                     format: '',
  //                     fileName: ''
  //                 },
  //             })
  //         })
  //     } else {
  //         var error = { ...this.state.uploadAssesmentError };
  //         error.msg = this.props.t('ALL_FIELDS_REQUIRED');
  //         error.show = true;
  //         this.setState({
  //             uploadAssesmentError: error
  //         })
  //     }
  // }

  uploadAssessment = () => {
    if (
      !this.state.assessmentData.files ||
      this.state.assessmentData.files.length === 0
    ) {
      var error = { ...this.state.uploadAssesmentError };
      error.show = true;
      error.msg = this.props.t("PLEASE_SELECT_FILE_TO_UPLOAD");
      this.setState({
        uploadAssesmentError: error,
      });
      return;
    }
    if (this.state.assessmentData.files?.length > 0) {
      var payload = {};
      payload = this.state.assessmentData.files.map((file) => ({
        document: {
          data: file.data,
          // name: this.state.assessmentData.name,
          name: file.fileName,
          format: file.format,
          description: "",
          isPublic:
            this.props.providerType === "SALES_CHNL_PROVIDER"
              ? file.isPublic
              : "Y",
        },
      }));
      let search = new URLSearchParams(this.props.router.location.search);
      let tenantId = search.get("tenantId");
      if (tenantId && this.props.providerType !== "SALES_CHNL_PROVIDER") {
        payload.forEach((doc) => (doc.tenantId = tenantId));
      }
      if (this.state.attachments && this.state.attachments.length > 0) {
        var isDuplicateFile = this.state.attachments.some(
          (x) =>
            x.name.toLowerCase() ===
            this.state.assessmentData.name.toLowerCase(),
        );
        if (isDuplicateFile) {
          var error = { ...this.state.uploadAssesmentError };
          error.show = true;
          error.msg = this.props.t("DUPLICATE_ATTACHMENT_NAME");
          this.setState({
            uploadAssesmentError: error,
          });
          return;
        }
      }
      if (tenantId) {
        payload.tenantId = tenantId;
      }
      this.setState({
        loading: true,
        showUploadDailog: false,
      });
      BusApiCall(
        "POST",
        `${constants.busV44UrlPublic}/orders/${this.state.orderId}/attachment`,
        payload,
      )
        .then((res) => {
          BusApiCall(
            "GET",
            `${constants.busV44UrlPublic}/orders/${this.state.orderId}/attachments`,
            payload,
          )
            .then((res) => {
              if (res && res.data && res.data.attachments) {
                this.setState({
                  attachments: res.data.attachments,
                  loading: false,
                });
              }
            })
            .catch((err) => { });
          this.props.setErrorMessage(
            this.props.t("DOCUMENT_UPLOADED_SUCCESSFULLY"),
            true,
          );
          this.setState({
            assessmentData: {
              name: "",
              data: "",
              format: "",
              fileName: "",
              isPublic: "N",
            },
            showUploadDailog: false,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            console.log("err", err);
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            showUploadDailog: false,
            assessmentData: {
              name: "",
              data: "",
              format: "",
              fileName: "",
              isPublic: "N",
            },
          });
        });
    } else {
      var error = { ...this.state.uploadAssesmentError };
      error.msg = this.props.t("PLEASE_SELECT_FILE_TO_UPLOAD");
      error.show = true;
      this.setState({
        uploadAssesmentError: error,
      });
    }
  };

  openProductSpecification = (offeringIndex, productId) => {
    var solutions = [...this.state.solutions];
    var offering = solutions.findIndex(
      (obj) => obj.packageId === offeringIndex.packageId,
    );
    if (offering > -1) {
      var product = solutions[offering].associatedItems.findIndex(
        (obj) => obj.productId === productId,
      );
      if (product > -1) {
        if (solutions[offering].associatedItems[product].expandChar) {
          solutions[offering].associatedItems[product].expandChar = false;
        } else {
          solutions[offering].associatedItems[product].expandChar = true;
        }
        this.setState({
          solutions: solutions,
        });
      }
    }

    // this.setState({
    //     selectedProductSpecificationOffering: offering,
    //     selectedProductSpecification: product,
    //     showProductSpecification: true,
    // })
  };

  handleCloseSpecificationDialog = () => {
    this.setState({
      selectedProductSpecificationOffering: {},
      selectedProductSpecification: {},
      showProductSpecification: false,
    });
  };

  handleCharacteristicsUpdate = (updatedCharacteristics) => {
    // this.setState({ loading: true });
    // var oldData = [...this.state.cartData];
    // var cartItem = oldData[0].cartItem;
    // var index = cartItem.findIndex((x) => x.index === this.state.selectedProductSpecificationOffering.index);
    // var selectedCartItem = cartItem[index];
    // var productIndex = selectedCartItem.productOffering.includedItems.findIndex((x) => x.id === this.state.selectedProductSpecification.id);
    // var selectedProduct = selectedCartItem.productOffering.includedItems[productIndex];
    // if (selectedProduct.productSpec && selectedProduct.productSpec.category) {
    //     if (selectedProduct.productSpec.category === 'PSC_CUST_FACING') {
    //         selectedProduct.productCharsOverride = [];
    //         updatedCharacteristics.map(char => (
    //             selectedProduct.productCharsOverride.push({
    //                 name: char.name,
    //                 value: char.value,
    //                 specId: char.specId,
    //                 id: char.id,
    //             })
    //         ));
    //     }
    // }
    // selectedCartItem.productOffering.includedItems[productIndex] = selectedProduct;
    // selectedCartItem.action = 'MODIFY';
    // var payload = {
    //     cartItem: []
    // }
    // if (this.props.providerType === 'SOLUTION_PROVIDER') {
    //     payload.tenantId = localStorage.getItem('selectedSalesChannel');
    // }
    // payload.cartItem.push(selectedCartItem);
    // BusApiCall('PATCH', `${constants.busPublicServiceUrl}/shoppingCart/${this.state.cartData[0].id}`, payload).then(res => {
    //     this.props.setErrorMessage(this.props.t('CHARACTERISTIC_UPDATED_SUCCESSFULLY'), true);
    //     if (this.state.customerDetails.childFirstName) {
    //         this.getCustomerCart(this.state.customerDetails.partyId)
    //     } else {
    //         this.getCustomerCart(this.state.customerDetails.partyId, this.state.customerDetails.ban)
    //     }
    // }).catch(err => {
    //     if (err.response && err.response.data && err.response.data.message) {
    //         this.props.setErrorMessage(err.response.data.message, false)
    //     } else {
    //         this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
    //     }
    //     this.setState({
    //         loading: false,
    //     })
    // })
  };

  render() {
    const { t } = this.props;
    const { classes: jssClasses } = this.props;
    return (
      // this.props.match.isExact ?
      // :
      // <RouterSwitch>
      //     {/* <Route exact path='/order/:orderId/product' element={Catalog} />
      //     <Route path='/order/:orderId/product/:id' element={(props) => <Product {...props} addItem={this.addItem} />} />
      //     <Route exact path='/order/:orderId/contact' element={(props) =>
      //         <UpdateOrderContact updateInfo={this.getFullOrderDetails} {...props} />
      //     } /> */}
      //     {
      //         this.state.vRoute.map((route, index) =>
      //             <Route key={index} path={route.path} element={
      //                 route.name === 'Product' ?
      //                     (props) => <Product {...props} addItem={this.addItem} />
      //                     :
      //                     route.name === 'UpdateOrderContact' ? (props) => <UpdateOrderContact updateInfo={this.getFullOrderDetails} {...props} />
      //                         :
      //                         route.comp
      //             }></Route>
      //         )
      //     }
      // </RouterSwitch>
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Breadcrumb list={this.state.bread} />
                <div className={"bottomBreadcrumbText"}>
                  <div
                    style={{
                      display: "flex",
                      gap: ".5rem",
                      alignItems: "center",
                    }}
                  >
                    {this.state.orderTypeDescription &&
                      this.state.orderTypeDescription !== "" && (
                        <h2
                          className="text-ui"
                          style={{
                            marginBottom: 0,
                            fontWeight: "bold",
                          }}
                        >
                          {this.props.t("TYPE")}:{" "}
                          {this.state.orderTypeDescription}
                        </h2>
                      )}
                    <h2 className={classes.orderHeaderInfo}>
                      {/* {t('ORDER')}: #{this.props.router.params.orderId} */}
                      <b style={{ paddingLeft: "0px" }}>
                        {/* {t('STATUS')}: {this.state.status} */}
                        {this.state.status && (
                          <Chip
                            size="normal"
                            className={
                              this.state.status === "Order Fulfilled"
                                ? "successChip"
                                : "inProgressChip"
                            }
                            label={this.state.status}
                          />
                        )}
                      </b>
                      {/* {this.state.externalId ?
                                                <>
                                                    <br />
                                                    <b style={{ fontWeight: 'normal', paddingLeft: 0 }}>
                                                        {t('CUSTOMER_ORDER_NUMBER')}: #{this.state.externalId} <Tooltip title={t('EDIT')}><EditIcon style={{ position: 'relative', top: '3px' }} onClick={() => this.toggleCustomerOrderNumberDailog(this.state.externalId)} /></Tooltip>
                                                    </b>
                                                </>
                                            :
                                                <>
                                                    <br />
                                                    <b style={{ fontWeight: 'normal', paddingLeft: 0 }}>
                                                        {t('CUSTOMER_ORDER_NUMBER')}: <Tooltip title={t('NOT_AVAILABLE')}><span>{t('NA')}</span></Tooltip> <Tooltip title={t('EDIT')}><EditIcon style={{ position: 'relative', top: '3px' }} onClick={() => this.toggleCustomerOrderNumberDailog(this.state.externalId)} /></Tooltip>
                                                    </b>
                                                </>
                                            } */}
                      {/* {this.props.providerType !== 'SOLUTION_PROVIDER' && this.state.viewInvoice &&
                                                <b style={{ cursor: 'pointer', color: this.props.tenantData.color }}
                                                    onClick={(e) => { this.props.router.navigate(`/billing?orderId=${this.props.router.params.orderId}&userId=${this.state.orderBillToCustomerId}`) }}>
                                                    {t('VIEW_INVOICE')}
                                                </b>
                                            } */}
                    </h2>
                  </div>
                </div>
              </Grid>
              <Grid
                item
                style={{ textAlign: "right", paddingTop: "15px" }}
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                {this.state.renderActions && (
                  <Action
                    selectAction={this.selectAction}
                    autoActivatable={this.state.autoActivatable}
                    status={this.state.status}
                    orderActivationStatus={this.state.orderActivationStatus}
                    providerType={this.props.providerType}
                    downloadInvoice={this.state.downloadInvoice}
                    downloadInvoicePdf={() => this.downloadInvoicePdf()}
                    color={this.props.tenantData.color}
                    id={this.props.router.params.orderId}
                    menuPaths={this.props.menuPaths}
                    userPerms={this.props.userPerms}
                    formFields={this.state.formFields}
                    showActionDialog={this.showActionDialog}
                    openDiagramDialog={this.openDiagramDialog}
                    processInstanceDiagram={this.state.processInstanceDiagram}
                    bpmnProcessInstanceId={this.state.bpmnProcessInstanceId}
                    workFlowEnabled={this.state.workFlowEnabled}
                    loggedInUserType={this.props.loggedInUserType}
                    returnableItemList={this.state.returnableItemList}
                    togglePrtialProcessingDailog={
                      this.togglePrtialProcessingDailog
                    }
                  />
                )}
              </Grid>
            </Grid>
            {/* <Breadcrumb list={this.state.bread} />
                            {this.state.msg ? <h4>{this.state.msg}==</h4> : null}
                            <div className={classes.headerDiv}>
                                <div>
                                    <h2 className={classes.checkoutTitle}>{`Order #${this.props.router.params.orderId}`}</h2>
                                    <h3 className={classes.statusTitle}> {`Status : ${this.state.status}`}</h3>

                                    {this.props.providerType !== 'SOLUTION_PROVIDER' && this.state.downloadInvoice &&
                                        <h3 style={{ fontSize: '14px', marginTop: '10px' }}
                                            onClick={() => { this.downloadInvoicePdf() }}
                                            className={"goBack"}
                                        >
                                            {t('DOWNLOAD_INVOICE')}
                                        </h3>
                                    }
                                    {this.props.providerType !== 'SOLUTION_PROVIDER' && this.state.viewInvoice &&
                                        <h3 style={{ fontSize: '14px', marginTop: '10px' }}
                                            onClick={(e) => { this.props.router.navigate(`/billing?orderId=${this.props.router.params.orderId}&userId=${this.state.orderBillToCustomerId}`) }}
                                            className={"goBack"}
                                        >
                                            {t('VIEW_INVOICE')}
                                        </h3>
                                    }

                                    {this.state.showOrderInvoice &&
                                        <div style={{ marginBottom: 15 }}>
                                            <span style={{ marginRight: 10, fontSize: 16 }}>{t('ORDER_HAS_ITEMS_READY_FOR_INVOICE')}</span>
                                            <Button disabled={this.state.disableInvoiceBtn} onClick={() => { this.invoiceOrder() }}>{t('INVOICE_NOW')}</Button>
                                        </div>
                                    }

                                </div>

                                <Action selectAction={this.selectAction} autoActivatable={this.state.autoActivatable} status={this.state.status} orderActivationStatus={this.state.orderActivationStatus}
                                     providerType={this.props.providerType} />
                            </div> */}
          </div>
        </div>
        <main>
          {/* <div
                        onClick={() => { this.props.router.navigate("/orders") }}
                        className={"goBack"}
                    >
                        &#8592; Back to Orders
                    </div> */}

          {this.props.providerType === "SALES_CHNL_PROVIDER" &&
            this.state.status === "Waiting For Customer Acceptance" ? (
            <div>
              <div className={classes.tcMainMessage}>
                {t("ACCEPT_T&C_INFO_MESSAGE")}
              </div>
              <div className={classes.tcInfoMessage}>
                <InfoIcon /> {t("CHECK_SPAN/JUNK_MESSAGE")}
              </div>
            </div>
          ) : null}
          {this.state.customerDetails ? (
            // (!this.state.tenantId || this.props.providerType === 'SALES_CHNL_PROVIDER') &&
            <>
              <CustomerDetailBlock
                customerDetails={this.state.customerDetails}
                editOption={this.state.modify}
                edit={this.updateCustomerDetails}
                providerType={this.props.providerType}
              />
            </>
          ) : null}
          <div style={{ marginTop: 25 }}></div>
          <div>
            {/* {this.state.renderCartBlock && this.state.orderStatus !== 'ORDER_COMPLETED' &&
                                this.state.orderStatus !== 'ORDER_INITIATED' && this.state.orderType === 'NewActivation' &&
                                <div className={classes.customIconButton} style={{ float: 'right', marginLeft: '15px' }}>
                                    <>
                                        <span onClick={() => this.setState({ showPartialProcessDialog: true })} style={{ color: this.props.tenantData.color }}>
                                            {t('PROCESS_ORDER')} &nbsp;
                                        </span>
                                        <Tooltip title={t('PROCESS_ORDER')}>
                                            <IconButton onClick={() => this.setState({ showPartialProcessDialog: true })}>
                                                <ProcessOrderIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </>
                                </div>
                            } */}
            {this.props.userPerms.includes("ORDERMGR_RETURN") &&
              this.state.status === "Order Fulfilled" &&
              this.state.returnableItemList &&
              this.state.returnableItemList.length > 0 && (
                <div
                  className={classes.customIconButton}
                  style={{ float: "right" }}
                >
                  <>
                    <span
                      onClick={() => {
                        this.props.router.navigate(
                          `/return/${this.state.orderId}`,
                        );
                      }}
                      style={{ color: this.props.tenantData.color }}
                    >
                      {t("RETURN")} &nbsp;
                    </span>
                    <Tooltip title={t("RETURN")}>
                      <IconButton
                        onClick={() => {
                          this.props.router.navigate(
                            `/return/${this.state.orderId}`,
                          );
                        }}
                      >
                        <ReturnIcon />
                      </IconButton>
                    </Tooltip>
                  </>
                </div>
              )}
            <div style={{ clear: "both" }}></div>
          </div>
          {this.state.renderCartBlock && (
            <div>
              <CartBlock
                solutionList={this.state.solutions}
                accessoryList={this.state.accessories}
                orderTypeDescription={this.state.orderTypeDescription}
                remove={this.removeItem}
                changeQuantity={this.changeQuantity}
                changeAccPrice={this.changeAccPrice}
                edit={this.state.edit}
                orderStatus={this.state.status}
                componentList={this.props.componentList}
                providerType={this.props.providerType}
                totalRCDiscount={this.state.totalRCDiscount}
                totalNRDiscount={this.state.totalNRDiscount}
                orderCustomer={this.state.orderCustomer}
                clearCustomer={this.clearCustomer}
                editCustomer={this.editCustomer}
                updateLineItemClient={this.updateLineItemClient}
                orderType={this.state.orderType}
                note={this.state.note}
                associatedOrder={this.state.associatedOrder}
                orderDiscount={this.state.orderDiscount}
                orderTotalDiscount={this.state.orderTotalDiscount}
                notes={this.state.notes}
                changeNotes={this.changeNotes}
                confirmNote={this.confirmNote}
                status={this.state.status}
                openProductSpecification={this.openProductSpecification}
              />
            </div>
          )}
          {this.state.modify ? (
            <div className={classes.OrderModifyDiv}>
              <Button
                onClick={() => {
                  this.setEdit({
                    quantity: !this.state.edit.quantity,
                    item: false,
                    price: !this.state.edit.price,
                  });
                }}
              >
                {this.state.edit.quantity ? t("Done") : t("Edit quantity")}
              </Button>
              <Button
                onClick={() => {
                  this.props.router.navigate(
                    `${this.props.router.location.pathname}/product`,
                  );
                }}
              >
                {t("ADD_SOLUTION_&_ACCESSORIES")}
              </Button>
              <Button
                style={{ float: "right" }}
                onClick={() => {
                  this.updateOrder();
                }}
              >
                {this.props.providerType === "SALES_CHNL_PROVIDER"
                  ? t("UPDATE_ORDER")
                  : t("UPDATE_FULFILMENT_REQUEST")}
              </Button>
              <Button
                style={{ float: "right" }}
                onClick={() => {
                  this.cancelModify();
                }}
              >
                {t("CANCEL_UPDATE")}
              </Button>
            </div>
          ) : null}
          {/* Order history block */}
          {this.state.renderCartBlock && (
            <OrderHistory
              statusHistory={this.state.statusHistory}
              subscriptionChangeHistory={this.state.subscriptionChangeHistory}
              tcInformation={this.state.tcInformation}
              tcLinks={this.state.tcLinks}
              downloadPdf={this.downloadPdf}
              getOrderHistory={this.getOrderFullHistory}
              tenantId={this.state.tenantId}
              providerType={this.props.providerType}
              color={this.props.tenantData.color}
              formFields={this.state.formFields}
              showActionDialog={this.showActionDialog}
              workFlowEnabled={this.state.workFlowEnabled}
              is_order_status={this.state.is_order_status}
              order_status_details={this.state.order_status_details}
              returnOrders={this.state.returnOrders}
              note={this.state.note}
              associatedOrder={this.state.associatedOrder}
              attachments={this.state.attachments}
              toggleChildProcessDialog={this.toggleChildProcessDialog}
              expandChildProcess={this.expandChildProcess}
              openHistoryDiagramDialog={this.openHistoryDiagramDialog}
              togglePrtialProcessingDailog={this.togglePrtialProcessingDailog}
              orderType={this.state.orderType}
              orderStatus={this.state.status}
              orderDate={this.state.orderDate}
              isEligibleUser={this.state.isEligibleUser}
              eligibleRole={this.state.eligibleRole}
              editProcessData={this.editProcessData}
              priceSummaryView={this.props.priceSummaryView}
              downloadAttchemnt={this.downloadAttchemnt}
              editVisibility={this.editVisibility}
              showUploadDailog={this.state.showUploadDailog}
              openUploadAttachmentDialog={this.openUploadAttachmentDialog}
              userPerms={this.props.userPerms}
              securityGroupsList={this.props.securityGroupsList}
              subscriptionData={this.state.subscriptionData}
              subsHistoryTotalRecords={this.state.subsHistoryTotalRecords}
              subsHistoryPage={this.state.subsHistoryPage}
              subsHistoryPerPage={this.state.subsHistoryPerPage}
              updateSubsHistoryPerPageRows={this.updateSubsHistoryPerPageRows}
              onSubsHistoryPageChange={this.onSubsHistoryPageChange}
              openSubscription={this.openSubscription}
              orderId={this.state.orderId}
              setErrorMessage={this.props.setErrorMessage}
              router={this.props.router}
              packageInstanceBilled={this.state.packageInstanceBilled}
            />
          )}
          {/* Order approval options start */}
          {this.displayActionBlock() && this.state.showActions && (
            <Grid container spacing={3} style={{ marginTop: "15px" }}>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                {this.state.showActionsPanel && (
                  <>
                    <>
                      {/* If work flow enabled start */}
                      {this.state.workFlowEnabled && (
                        <>
                          {this.state.formFields &&
                            this.state.formFields.fields &&
                            this.state.formFields.fields.length > 0 &&
                            this.state.actionDialog && (
                              <OrderActionDialog
                                data={this.state.formFields}
                                open={this.state.actionDialog}
                                close={this.closeActionDialog}
                                bpmnProcessInstanceId={
                                  this.state.bpmnProcessInstanceId
                                }
                                minDate={this.state.orderDate}
                                actionStatus={this.state.actionStatus}
                              />
                            )}
                        </>
                      )}
                      {/* If work flow enabled end */}
                      {/* If work flow not enabled start */}
                      <div>
                        {!this.state.workFlowEnabled &&
                          this.state.status === "Review to be Completed" && (
                            <>
                              {this.props.userPerms.includes(
                                "ORDERMGR_UPDATE",
                              ) && (
                                  <div
                                    style={{
                                      marginTop: "25px",
                                      textAlign: "right",
                                    }}
                                  >
                                    <Button
                                      onClick={() =>
                                        this.updateOrderStatus(
                                          "REJECTED_IN_REVIEW",
                                        )
                                      }
                                    >
                                      {" "}
                                      {this.props.providerType ===
                                        "SALES_CHNL_PROVIDER"
                                        ? t("REJECT_ORDER")
                                        : t("REJECT_FULFILMENT_REQUEST")}
                                    </Button>
                                    <Button
                                      style={{ marginLeft: "15px" }}
                                      onClick={() =>
                                        this.updateOrderStatus(
                                          "ACCEPTED_IN_REVIEW",
                                        )
                                      }
                                    >
                                      {" "}
                                      {this.props.providerType ===
                                        "SALES_CHNL_PROVIDER"
                                        ? t("ACCEPT_ORDER")
                                        : t("ACCEPT_FULFILMENT_REQUEST")}
                                    </Button>
                                  </div>
                                )}
                            </>
                          )}
                      </div>
                      {/* If work flow not enabled end */}
                    </>
                  </>
                )}
                {/* {this.props.providerType == 'SOLUTION_PROVIDER' && <>
                                {this.state.status === 'Site Review to be Scheduled' ||
                                    this.state.status === 'Site Survey and Interview to be Completed' ||
                                    this.state.status === 'Installation to be Scheduled' ||
                                    this.state.status === 'Installation to be Completed' ?
                                    <div className={statusClasses.subTitleDiv, statusClasses.historyWrapper}>
                                        <h3>
                                            <span>
                                                {t('ACTION')} :&nbsp;
                                                {this.state.status === 'Site Review to be Scheduled' && 'Site Review to be Scheduled'}
                                                {this.state.status === 'Site Survey and Interview to be Completed' && 'Site Survey and Interview to be Completed'}
                                                {this.state.status === 'Installation to be Scheduled' && 'Installation to be Scheduled'}
                                                {this.state.status === 'Installation to be Completed' && 'Installation to be Completed'}
                                            </span>
                                        </h3>
                                    </div>
                                    :
                                    null
                                }
                            </>
                            }
                            <div>
                                {this.props.providerType == 'SOLUTION_PROVIDER' && <>
                                    {this.state.status === 'Site Review to be Scheduled' &&
                                        <>
                                            <div>
                                                <TextField
                                                    name="orderUpdateDate"
                                                    id="orderUpdateDate"
                                                    type="date"
                                                    value={this.state.orderUpdateDate}
                                                    label="Site Review Scheduled for "
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    variant={'outlined'}
                                                    size={'small'}
                                                    onChange={(e) => { this.setState({ orderUpdateDate: e.target.value }) }}
                                                    inputProps={{ format: "MM/dd/yyyy" }}
                                                    onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                                    style={{ width: '300px', marginBottom: '15px' }}
                                                />
                                            </div>
                                            <Button
                                                onClick={() => this.updateOrderStatus('for ' + this.state.orderUpdateDate)}
                                                disabled={!this.state.orderUpdateDate}>{t(this.state.updateOrderLabel)}</Button>
                                        </>
                                    }
                                    {this.state.status === 'Site Survey and Interview to be Completed' &&
                                        <>
                                            <div>
                                                <TextField
                                                    name="orderUpdateDate"
                                                    id="orderUpdateDate"
                                                    type="date"
                                                    value={this.state.orderUpdateDate}
                                                    label="Site Survey Completed on"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    variant={'outlined'}
                                                    size={'small'}
                                                    onChange={(e) => { this.setState({ orderUpdateDate: e.target.value }) }}
                                                    inputProps={{ format: "MM/dd/yyyy" }}
                                                    onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                                    style={{ width: '300px', marginBottom: '15px' }}
                                                />
                                            </div>
                                            <Button
                                                onClick={() => this.updateOrderStatus('on ' + this.state.orderUpdateDate)}
                                                disabled={!this.state.orderUpdateDate}>{t(this.state.updateOrderLabel)}</Button>
                                        </>
                                    }
                                    {this.state.status === 'Installation to be Scheduled' &&
                                        <>
                                            <div>
                                                <TextField
                                                    name="orderUpdateDate"
                                                    id="orderUpdateDate"
                                                    type="date"
                                                    value={this.state.orderUpdateDate}
                                                    label="Installation Scheduled for"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    variant={'outlined'}
                                                    size={'small'}
                                                    onChange={(e) => { this.setState({ orderUpdateDate: e.target.value }) }}
                                                    inputProps={{ format: "MM/dd/yyyy" }}
                                                    onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                                    style={{ width: '300px', marginBottom: '15px' }}
                                                />
                                            </div>
                                            <Button
                                                onClick={() => this.updateOrderStatus('for ' + this.state.orderUpdateDate)}
                                                disabled={!this.state.orderUpdateDate}>{t(this.state.updateOrderLabel)}</Button>
                                        </>
                                    }
                                    {/* {this.state.status === 'Activation to be Completed' &&
                                    <>
                                        <div>
                                            <TextField
                                                name="orderUpdateDate"
                                                id="orderUpdateDate"
                                                type="date"
                                                value={this.state.orderUpdateDate}
                                                label="This should be removed DATE"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                variant={'outlined'}
                                                size={'small'}
                                                onChange={(e) => { this.setState({ orderUpdateDate: e.target.value }) }}
                                                inputProps={{ format: "MM/dd/yyyy" }}
                                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                                style={{ width: '300px', marginBottom: '15px' }}
                                            />
                                        </div>
                                        <Button
                                            onClick={() => this.updateOrderStatus('on ' + this.state.orderUpdateDate)}
                                            disabled={!this.state.orderUpdateDate}>{t(this.state.updateOrderLabel)}</Button>
                                    </>
                                } */}
                {/* {this.state.status === 'Installation to be Completed' &&
                                        <>
                                            <div>
                                                <TextField
                                                    name="orderUpdateDate"
                                                    id="orderUpdateDate"
                                                    type="date"
                                                    value={this.state.orderUpdateDate}
                                                    label="Installation Completed on"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    variant={'outlined'}
                                                    size={'small'}
                                                    onChange={(e) => { this.setState({ orderUpdateDate: e.target.value }) }}
                                                    inputProps={{ format: "MM/dd/yyyy" }}
                                                    onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                                    style={{ width: '300px', marginBottom: '15px' }}
                                                />
                                            </div>
                                            <Button
                                                onClick={() => this.updateOrderStatus('on ' + this.state.orderUpdateDate)}
                                                disabled={!this.state.orderUpdateDate}>{t(this.state.updateOrderLabel)}</Button>
                                        </>
                                    }
                                </>
                                }
                            </div> */}
              </Grid>
            </Grid>
          )}

          {/* Otrder approval options end */}

          <Loader loading={this.state.loading} />
          {/* Resend T&C email dialog */}
          <ResendDialog
            isOpen={this.state.isMailDialog}
            close={this.closeMailDialog}
            orderId={this.state.orderId}
          />
          {/* Cancel order dialog */}
          <CancelOrderDialog
            isOpen={this.state.isCancelDialog}
            close={this.closeCancelDialog}
            orderId={this.state.orderId}
          />
          {this.state.is_order_status && this.state.actionDialog && (
            <OrderActionDialog
              data={this.state.formFields}
              open={this.state.actionDialog}
              close={this.closeActionDialog}
              bpmnProcessInstanceId={this.state.bpmnProcessInstanceId}
              minDate={this.state.orderDate}
              actionStatus={this.state.actionStatus}
            />
          )}
          {this.state.showChildActionDailog && (
            <OrderActionDialog
              data={this.state.selectedChildProcessData.taskDetails}
              open={this.state.showChildActionDailog}
              close={this.closeChildActionDialog}
              bpmnProcessInstanceId={
                this.state.selectedChildProcessData.bpmnProcessInstanceId
              }
              minDate={this.state.orderDate}
              actionStatus={this.state.actionStatus}
            />
          )}
          {this.state.showCustomerOrderNumberDialog && (
            <Dialog
              disableScrollLock={true}
              PaperComponent={this.draggableDialogPaper}
              open={this.state.showCustomerOrderNumberDialog}
              maxWidth={"sm"}
              fullWidth={true}
              PaperProps={
                {
                  // className: jssClasses.resizablePaper
                }
              }
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {t("UPDATE_CUSTOMER_ORDER_NUMBER")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onTouchStart={() => {
                        this.toggleCustomerOrderNumberDailog("");
                      }}
                      onClick={() => {
                        this.toggleCustomerOrderNumberDailog("");
                      }}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers style={{ overflow: "hidden" }}>
                <Input
                  // inputClass={classes.notesInput}
                  name={"tempExternalId"}
                  variant={"outlined"}
                  size={"small"}
                  placeholder={t("CUSTOMER_ORDER_NUMBER")}
                  value={this.state.tempExternalId}
                  // onChange={(e) => { this.onChangeInput(e) }}
                  onChange={(e) =>
                    this.inputAlphaNumeric(e, (value) => {
                      this.onChangeInput(e);
                    })
                  }
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    this.toggleCustomerOrderNumberDailog("");
                  }}
                >
                  {t("CANCEL")}
                </Button>
                <Button
                  onClick={() => {
                    this.updateCustomerOrderNumber();
                  }}
                >
                  {t("UPDATE")}
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {this.state.showPartialProcessDialog && (
            <PartialOrderProcessDialog
              open={this.state.showPartialProcessDialog}
              close={this.togglePrtialProcessingDailog}
              data={JSON.stringify(this.state.processingItemData)}
              orderId={this.state.orderId}
              tenantId={this.state.tenantId}
            />
          )}
          {this.state.editPartialProcessDialog && (
            <EditPartialOrderProcessDialog
              open={this.state.editPartialProcessDialog}
              close={this.toggleEditPrtialProcessingDailog}
              data={JSON.stringify(this.state.editProcessingItemData)}
              orderId={this.state.orderId}
              tenantId={this.state.tenantId}
              quantityData={JSON.stringify(this.state.processingItemData)}
              reloadPartialOrderProcessingData={
                this.reloadPartialOrderProcessingData
              }
            />
          )}
          {this.state.showUploadDailog && (
            <Dialog
              open={this.state.showUploadDailog}
              PaperComponent={this.draggableDialogPaper}
              aria-labelledby="form-dialog-title"
              fullWidth={true}
              maxWidth={"sm"}
            >
              <DialogTitle
                id="draggableDialogPaper"
                style={{ cursor: "move" }}
                className={classes.paymentMethods}
              >
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {this.props.t("UPLOAD")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onTouchStart={() =>
                        this.setState({
                          showUploadDailog: false,
                          assessmentData: {
                            name: "",
                            data: "",
                            fileName: "",
                            format: "",
                          },
                          uploadAssesmentError: { show: false, msg: "" },
                        })
                      }
                      onClick={() =>
                        this.setState({
                          showUploadDailog: false,
                          assessmentData: {
                            name: "",
                            data: "",
                            fileName: "",
                            format: "",
                          },
                          uploadAssesmentError: { show: false, msg: "" },
                        })
                      }
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                {/* <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Input
                                                name={"name"}
                                                value={this.state.assessmentData.name}
                                                variant={"outlined"}
                                                onChange={(event) => this.onChangeAssesment(event)}
                                                placeholder={this.props.t("NAME") + " *"}
                                                size={"small"}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Input
                                                inputProps={{
                                                    id: "documentFile",
                                                    accept: "application/pdf, image/png, image/jpeg, image/jpg",
                                                    multiple: true
                                                }}
                                                type="file"
                                                name={"documentFile"}
                                                className="custom-file-input"
                                                onChange={(event) => this.onDocumentUpload(event)}
                                                style={{ display: 'none' }}
                                            />
                                            <label htmlFor="documentFile" className="custom-file-button" style={{
                                                padding: '8px 16px',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                cursor: 'pointer'
                                            }}>
                                                <Icon>attach_file</Icon>
                                                <label>
                                                    {" "}
                                                    {this.state.assessmentData.fileName?.length > 0 ? (
                                                        this.state.assessmentData.fileName.join(", ")
                                                    ) : (
                                                        <span className="input-file-placeholder">{t("UPLOAD_DOCUMENT_FILE_PDF_IMAGES_ONLY")}</span>
                                                    )}
                                                </label>
                                            </label>
                                            <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem' }}>{t('MAX_FILE_SIZE_5MB')}</span>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        color="primary"
                                                        checked={this.state.assessmentData.isPublic === 'Y' || this.props.providerType !== 'SALES_CHNL_PROVIDER'}
                                                        name="isPublic" 
                                                        onChange={(e) => {
                                                            const isPublic = e.target.checked ? 'Y' : 'N';
                                                            this.setState({
                                                                assessmentData: {
                                                                    ...this.state.assessmentData,
                                                                    isPublic
                                                                }
                                                            });
                                                        }}
                                                        disabled={this.props.providerType !== 'SALES_CHNL_PROVIDER'}
                                                    />
                                                }
                                                style={{
                                                    fontSize: '0.875rem',
                                                    color: 'rgba(0, 0, 0, 0.54)',
                                                    marginLeft: 0
                                                }}
                                                label={this.props.t('MAKE_PUBLIC')}
                                                labelPlacement='start'
                                            />
                                        </Grid>
                                    </Grid> */}
                <Grid container spacing={2}>
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <Input
                      inputProps={{
                        id: "documentFile",
                        accept:
                          "application/pdf, image/png, image/jpeg, image/jpg",
                        multiple: true,
                      }}
                      type="file"
                      name={"documentFile"}
                      className="custom-file-input"
                      onChange={(event) => this.onDocumentUpload(event)}
                      style={{ display: "none" }}
                    />
                    <label
                      htmlFor="documentFile"
                      className="custom-file-button"
                      style={{
                        padding: "8px 16px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Icon>attach_file</Icon>
                      <span style={{ marginLeft: "8px" }}>
                        {t("UPLOAD_FILE")}
                      </span>
                    </label>
                    <div style={{ marginTop: "4px" }}>
                      <span
                        className="text-body"
                        style={{
                          color: "rgba(0, 0, 0, 0.54)",
                        }}
                      >
                        The maximum allowed file size is 5MB. (Pdf and images
                        only)
                      </span>
                    </div>
                  </Grid>
                  {this.state.assessmentData.files &&
                    this.state.assessmentData.files.length > 0 && (
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <Card
                          variant="outlined"
                          style={{ borderRadius: "8px", marginTop: "1rem" }}
                        >
                          <TableContainer>
                            <Table className="newGlobalTable">
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      padding: "12px 16px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {t("FILE_NAME")}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: "12px 16px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {t("FILE_TYPE")}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: "12px 16px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {t("MAKE_PUBLIC")}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: "12px 16px",
                                      width: "60px",
                                    }}
                                  ></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.assessmentData.files.map(
                                  (file, index) => (
                                    <TableRow key={index}>
                                      <TableCell
                                        style={{ padding: "12px 16px" }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <img
                                            src={
                                              file.format === "application/pdf"
                                                ? pdfIcon
                                                : file.format ===
                                                  "image/jpeg" ||
                                                  file.format === "image/jpg"
                                                  ? jpgIcon
                                                  : file.format === "image/png"
                                                    ? pngIcon
                                                    : placeholderImage
                                            }
                                            style={{
                                              width: "24px",
                                              height: "24px",
                                              marginRight: "8px",
                                            }}
                                          />
                                          <Tooltip title={file.fileName}>
                                            <div
                                              style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "200px",
                                              }}
                                            >
                                              {file.fileName}
                                            </div>
                                          </Tooltip>
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        style={{ padding: "12px 16px" }}
                                      >
                                        {file.format
                                          .split("/")[1]
                                          .toUpperCase()}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          padding: "12px 16px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              color="primary"
                                              checked={
                                                file.isPublic === "Y" ||
                                                this.props.providerType !==
                                                "SALES_CHNL_PROVIDER"
                                              }
                                              onChange={(e) => {
                                                const files = [
                                                  ...this.state.assessmentData
                                                    .files,
                                                ];
                                                files[index].isPublic = e.target
                                                  .checked
                                                  ? "Y"
                                                  : "N";
                                                this.setState({
                                                  assessmentData: {
                                                    ...this.state
                                                      .assessmentData,
                                                    files,
                                                  },
                                                });
                                              }}
                                              disabled={
                                                this.props.providerType !==
                                                "SALES_CHNL_PROVIDER"
                                              }
                                            />
                                          }
                                          style={{ margin: 0 }}
                                          label=""
                                        />
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          padding: "12px 16px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            const files = [
                                              ...this.state.assessmentData
                                                .files,
                                            ];
                                            files.splice(index, 1);
                                            this.setState({
                                              assessmentData: {
                                                ...this.state.assessmentData,
                                                files,
                                              },
                                            });
                                          }}
                                        >
                                          <DeleteIconNew />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  ),
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Card>
                      </Grid>
                    )}
                </Grid>
              </DialogContent>
              <DialogActions style={{ justifyContent: "normal" }}>
                <Box style={{ width: '100%' }}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      size={{
                        xs: 9,
                      }}
                    >
                      {this.state.uploadAssesmentError.show && (
                        <span className="text-error" style={{ fontWeight: "bold" }}>
                          {this.state.uploadAssesmentError.msg}
                        </span>
                      )}
                    </Grid>
                    <Grid
                      item
                      style={{ textAlign: "right" }}
                      size={{
                        xs: 3,
                      }}
                    >
                      <Button
                        onClick={(event) => this.uploadAssessment()}
                        color="primary"
                      >
                        {this.props.t("UPLOAD")}
                      </Button>
                    </Grid>
                  </Grid>
                  {/* <div style={{ float: 'left' }}>
                                            {this.state.uploadAssesmentError.show &&
                                                <span style={{ fontWeight: 'bold', color: '#f44336' }}>
                                                    {this.state.uploadAssesmentError.msg}
                                                </span>
                                            }
                                        </div>
                                        <div style={{ float: 'right' }}>
                                            <Button onClick={event => this.uploadAssessment()} color="primary">{t('UPLOAD')}</Button>
                                        </div>
                                        <div style={{ clear: 'both' }}></div> */}
                </Box>
              </DialogActions>
            </Dialog>
          )}
          {/* {this.state.showProductSpecification &&
                            <>
                                <OfferingProductSpecCharacteristicsExistingDialog t={t} open={this.state.showProductSpecification} productId={this.state.selectedProductSpecification.productId} productName={this.state.selectedProductSpecification.productName} onClose={this.handleCloseSpecificationDialog} componentProductCharacteristics={this.state.selectedProductSpecification.productSpec ? this.state.selectedProductSpecification.productSpec : {}} onCharacteristicsChange={this.handleCharacteristicsUpdate} changedCharacteristics={this.state.selectedCharacteristics || []} screen='order' />
                            </>
                        } */}
        </main>
      </div>
    );
  }
}

// const jssStyles = {

//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     }
// }

const mapStateToProps = (state) => {
  return {
    componentList: state.cart.componentList,
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    userPerms: state.auth.userPerms,
    menuPaths: state.auth.menuPaths,
    loggedInUserType: state.auth.userLoginType,
    tenantInfo: state.auth.tenantInfo,
    securityGroupsList: state.auth.securityGroupsList,
    priceSummaryView: state.auth.priceSummaryView,
    accessToken: state.auth.access_token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Order)));
